export const jsonConstants = {
    DATA_KEY: 'data',
    CHART_DATA_KEY: 'chartData',
    ALL_COLUMNS_KEY: 'columns',
    ALL_RELATIONSHIPS_KEY: 'relationships',
    DESTINATION_RELATIONSHIPS: 'destinationRelationships',
    ALL_RELATIONSHIPS_WITHIN_KEY: 'relationshipsWithin',
    MULTIPLE_HEADER_KEY: 'headers',
    EFFECTIVE_CALENDAR_GUID: 'effectiveCalendarGuid',
    ERROR_CODE_KEY: 'errorCode',
    ENABLE_VIZ_DATA_EXPORT: 'enableVizDataExport',
    ALL_GROUP_ID: 'allUserGroupId',
    ALL_GROUP_DISPLAY_NAME: 'allUserGroupDisplayName',
    ALL_GROUP_USER_COUNT: 'allUserGroupMemberUserCount',
    DATA_SOURCE_ID: 'dataSourceId',
    ALL_ORGS_OVERRIDE: 'allOrgsOverride',
    REMOVE_SESSIONS_ME_DEPENDENCY: 'removeSessionsMeDependency',
    HEADER_KEY: 'header',
    ID_KEY: 'id',
    OWNER_KEY: 'owner',
    NAME_KEY: 'name',
    CREATED_KEY: 'created',
    NAMED_PROPERTIES_KEY: 'namedProperties',
    UNDERLYING_COLUMN_NAME_KEY: 'underlyingColumnName',
    DESCRIPTION_KEY: 'description',
    AUTHOR_KEY: 'author',
    AUTHOR_NAME: 'authorName',
    AUTHOR_DISPLAY_NAME: 'authorDisplayName',
    GENERATION_NUM_KEY: 'generationNum',
    IS_HIDDEN_KEY: 'isHidden',
    IS_DEPRECATED_KEY: 'isDeprecated',
    METRIC_DEFINITION_KEY: 'metricDefinition',
    METRICS: 'metrics',
    ENABLE_OPTIMIZELY_SERVICE: 'enableOptimizelyService',
    BASE_METRIC_DEFINITION_KEY: 'baseMetricDefinition',
    COMPLETION_RATIO: 'completionRatio',
    IS_AUTO_DELETE_KEY: 'isAutoDelete',
    IS_AUTO_CREATED_KEY: 'isAutoCreated',
    CURRENCY_TYPE_INFO_KEY: 'currencyTypeInfo',
    BASE_CURRENCY_TYPE_INFO_KEY: 'baseCurrencyTypeInfo',
    GEO_CONFIG_KEY: 'geoConfig',
    BASE_GEO_CONFIG_KEY: 'baseGeoConfig',
    MATERIALIZATION_CONFIGURATION: 'materializationConfig',
    MATERIALIZATION_HOURS: 'materializationHours',
    REFRESH_WINDOW_START_TIME: 'refreshWindowStartTime',
    REPORT_BOOK_METADATA_KEY: 'reportBookMetadata',
    REPORT_BOOK_CONTENT_KEY: 'reportContent',
    REPORT_BOOK_DATA_KEY: 'reportBookData',
    TOP_USERS: 'topUsers',
    REPORT_BOOK_RESOLVED_OBJECTS_KEY: 'resolvedObjects',
    SHEETS_KEY: 'sheets',
    FLOW_KEY: 'flow',
    DATA_SETS_KEY: 'dataSets',
    SHEETCONTENT_KEY: 'sheetContent',
    SHEET_CONTENT_TYPE_KEY: 'sheetContentType',
    QUESTION_KEY: 'question',
    EFFECTIVE_QUESTION_KEY: 'effectiveQuestion',
    QUESTION_RESOLVED_TOKEN_TEXT_KEY: 'resolvedText',
    SAGE_CONTEXT_PROTO_KEY: 'sageContextProto',
    SAGE_CONTEXT_INDEX_KEY: 'sageContextIndex',
    IS_CHASM_TRAP_QUERY_KEY: 'isChasmTrapQuery',
    INSIGHT_EXPLANATION: 'insightExplanation',
    VISUALIZATIONS_KEY: 'visualizations',
    REF_ANSWER_SHEET_KEY: 'refAnswerSheet',
    SCIM_JWT_ENABLED: 'jwtAuthEnabled',
    REF_ANSWER_BOOK_KEY: 'refAnswerBook',
    REF_ANSWER_SHEET_QUESTION_KEY: 'refAnswerSheetQuestion',
    REF_VIZ_ID_KEY: 'refVizId',
    REF_VIZ_IDS_KEY: 'refVizIds',
    WORKSHEET_KEY: 'worksheet',
    NATURAL_QUERY_KEY: 'naturalQuery',
    PINBOARD_A3_DETAILS_KEY: 'pinboardA3Details',
    A3_REQUEST_PROTO_KEY: 'a3RequestProto',
    A3_ANALYSIS_FACTS_PROTO_KEY: 'analysisFacts',
    IS_SAAS_CLUSTER: 'isSaas',
    VIZ_HEADER_KEY: 'header',
    VIZ_CONTENT_KEY: 'vizContent',
    VIZ_CONTAINER_KEY: 'vizContainer',
    VIZ_DATA_KEY: 'vizData',
    VIZ_LIST_KEY: 'vizList',
    VIZ_TYPE_KEY: 'vizType',
    VIZ_SUBTYPE_KEY: 'vizSubtype',
    VIZ_COMPLETE_KEY: 'complete',
    SCHEMA_VERSION: 'schemaVersion',
    IS_HOMEPAGE_V4_ENABLED: 'isHomepageV4Enabled',
    IS_NAVIGATION_V3_ENABLED: 'isNavigationV3Enabled',
    TABLE_FILTER_RESOLVED_TEXT_KEY: 'resolvedTextProto',
    TABLE_FILTER_RESOLVED_TOKEN_KEY: 'resolvedTokenProto',
    HEADLINE_CHART_VIEWS_AREA: 'HEADLINE_CHART_VIEWS_AREA',
    TYPE_KEY: 'type',
    CLIENT_STATE_KEY: 'clientState',
    INFO_CARD_TIP: 'infoCardSeen',
    COMMUNITY_LINK_TIP: 'communityLinkSeen',
    LEARN_LINK_TIP: 'learnLinkSeen',
    TRENDING_CARD_TIP: 'trendingCard',
    RECENTLY_VIEWED_CARD_TIP: 'recentlyViewedCard',
    ACTIVITY_CARD_TIP: 'activityCard',
    FAVORITE_CARD_TIP: 'favoriteCardTip',
    ENLITE_TOGGLE_TO_SEARCHIQ_TIP: 'enliteToggleToSearchIQTip',
    ENLITE_REFINEMENTS_MAPPED_TOKEN_TIP: 'enliteRefinementsMappedTokenTip',
    ENLITE_TOKEN_MAPPER_TIP: 'enliteTokenMapperTip',
    CHART_CONFIG_CHIP_TIP: 'chartConfigChipTip',
    ASK_AN_EXPERT_TIP: 'askAnExpertTip',
    DELAYED_SEARCH_TIP: 'delayedSearchTip',
    MAF_PANEL_TIP: 'mafPanelTip',
    CONV_ASSIST_TIP: 'convAssistTip',
    CONV_ASSIST_VISITED_TIP: 'convAssistVisitedTip',
    IS_STACKED_AS_PERCENT: 'yAxis.isStackedAsPercent',
    RESPONSIVE_LAYOUT_DISABLED: 'responsiveLayoutDisabled',
    MARKERS_ENABLED: 'markersEnabled',
    SHOW_LINEAR_REGRESSION_LINE: 'showLinearRegressionLine',
    IS_HEATMAP_OVERLAYED: 'isHeatmapOverlayed',
    SCRIPTABILITY_CONFIG: 'scriptabilityConfig',
    TABLE_INDEXING_CONFIG: 'tableIndexingConfig',
    LUMOS_CONFIG: 'lumosConfig',
    CUSTOM_OBJECTID_CONFIGURATION: 'customObjectIdConfiguration',
    gridConfig: {
        WIDGET_STATE: 'widgetState',
        WIDTH_STATE: 'widthState',
        SHOW_GRID_SUMMARY: 'showGridSummary',
        WRAP_TABLE_HEADER: 'wrapTableHeader',
        SHOW_TABLE_FOOTER: 'showTableFooter',
    },
    ORDERED_COLUMN_IDS: 'orderedColumnIds',
    pivotConfig: {
        PIVOT_STATE: 'pivotState',
        HIDE_PIVOT_SUMMARIES: 'hidePivotSummaries',
        SUMMARY_MODE: 'summaryMode',
        USE_FLAT_LAYOUT: 'useFlatLayout',
    },
    CONFIG_INFO_KEY: 'configInfo',
    MAX_COLUMN_LIMIT_FOR_LIGHT_COLUMNS: 'maxColumnLimitForLightColumns',
    DISABLE_WORKSHEET_SAMPLE_VALUES: 'disableWorksheetSampleValues',
    ENABLE_SAGE_USER_FEEBBACK: 'enableSageUserFeedback',
    MAX_FILTER_VALUES: 'maxFilterValues',
    HELP_CONFIG: 'blinkHelpConfigList',
    SUPPORT_CONFIG_ITEMS: 'blinkSupportConfigItems',
    ACTION_CONFIG: 'blinkActionConfigList',
    EMBED_ACTION_CONFIG: 'embedActionConfigList',
    QUERY_UPDATE_DEBOUNCE_THRESHOLD_MS: 'queryUpdateDebounceThresholdMS',
    USER_FILE_UPLOAD_SIZE: 'userFileUploadSizeLimit',
    ENABLE_LOCALIZATION: 'enableLocalization',
    USE_GET_ENCODING: 'useGetEncoding',
    AVAILABLE_CALENDARS: 'availableCalendars',
    HIDE_DATA_TAB_ON_NO_MANAGE_DATA_PERMISSION: 'hideDataTabOnNoManageDataPermission',
    NOTIFICATION_CONFIG: 'notificationConfig',
    GROUP_MEMBER_SHARE_NOTIFICATION_LIMIT: 'groupMemberShareNotificationLimit',
    SIGNUP_CONFIG: 'signUpConfiguration',
    ANALYST_ONBOARDING_CONFIG: 'analystOnboardingConfig',
    ANALYST_ONBOARDING_ENABLED: 'enabled',
    ANALYST_ONBOARDING_VIDEO: 'videoURL',
    TEAMS: 'teams',
    TEAMS_ENABLED: 'enabled',
    TEAMS_FAQ_URL: 'faqPageUrl',
    TEAMS_OFFER_URL: 'offerPageUrl',
    TEAMS_OWNER_PLAN_URL: 'ownerPlanPageUrl',
    TEAMS_OWNER_MEMBERSHIP_LIMIT: 'teamMembershipLimit',
    COMS: 'coms',
    HIDE_HOMEPAGE_LEFT_NAV: 'hideHomepageLeftNav',
    DISABLE_AUTHOR_NAME_SORT: 'disableAuthorNameSort',
    HOMEPAGE_USER_CUSTOMISATION_ENABLED: 'homepageUserCustomisationEnabled',
    MONITOR_RULE_AUTO_CREATE_ENABLED: 'monitorRuleAutoCreateEnabled',
    SCHEDULE_JOB_AUTO_CREATE_ENABLED: 'scheduleJobAutoCreateEnabled',
    DEPRECATED_FULL_HEIGHT_DISABLED: 'deprecatedFullHeightDisabled',
    FLIP_TOOLTIP_TO_CONTEXT_MENU_ENABLED: 'flipTooltipToContextMenuEnabled',
    CONTEXT_MENU_ENABLED_ON_WHICH_CLICK: 'contextMenuEnabledOnWhichClick',
    TAG_MANAGEMENT_ENABLED: 'tagManagementEnabled',
    COMS_V2_ENABLED: 'v2Enabled',
    IN_APP_NOTIFICATIONS_ENABLED: 'inAppNotificationsEnabled',
    IS_SLACK_BOT_ENABLED: 'isSlackBotEnabled',
    IS_MS_TEAMS_BOT_ENABLED: 'isMsTeamsBotEnabled',
    IS_MS_TEAMS_NOTIFICATION_PREFERENCE_ENABLED: 'isMsTeamsNotificationPreferenceEnabled',
    ENABLE_SERVER_SIDE_COMS_TOKEN: 'enableServerSideComsToken',
    DATA_USAGE_TAB_ENABLED: 'isRowUsageTabEnabled',
    ENABLE_HOME_WATCHLIST: 'enableHomeWatchlist',
    ENABLE_HTML_SANITISATION: 'enableHtmlSanitisation',
    ENABLE_ALERT_ON_HOME_WATCHLIST: 'enableAlertOnHomeWatchlist',
    SETUP_V2_ENABLED: 'setupV2Enabled',
    USER_PERSONA_CONFIGURATION: 'userPersonaConfiguration',
    DATA_MANAGEMENT_CHECK_ENABLED: 'dataManagementCheckEnabled',
    DEMO_DATA_CONFIG: 'demoDataConfiguration',
    DEMO_WORKSHEET_GUIDS: 'demoWorksheetGuids',
    DEMO_CONNECTION_GUIDS: 'demoConnectionGuids',
    DEMO_PINBOARD_GUIDS: 'demoPinboardGuids',
    ONBOARDING_CONFIG: 'onboardingConfiguration',
    ORG_SUB_DOMAIN_LIMIT: 'orgSubdomainNameCharLimit',
    EXPORT_OBJECT_LIMIT: 'tmlObjectExportRequestLimitForPrincipalTypes',
    ONBOARDING_ENABLED: 'enabled',
    ONBOARDING_VIDEO_URL: 'onboardingVideoURL',
    ONBOARDING_ACTIVITY: 'onboardingActivity',
    ONBOARDING_COMPLETE: 'onboardingComplete',
    ONBOARDING_SEEN: 'onboardingSeen',
    COPILOT_ONBOARDING_SEEN: 'copilotOnboardingSeen',
    CLOUD_BUSINESS_ONBOARDING_ENABLED: 'cloudBusinessOnboardingEnabled',
    WORKSHEET_TOUR_SEEN: 'worksheetTourSeen',
    AUTO_ANSWER_TOUR_SEEN: 'autoAnswerTourSeen',
    SOCIAL_PROOF: 'socialProof',
    SHARING_CONFIGURATION: 'sharingConfiguration',
    ENABLE_VIZ_SHARING: 'enableVizSharing',
    ENABLE_VIZ_SHARING_WITH_LINK: 'enableVizSharingWithLink',
    ENABLE_DATA_SOURCE_SHARING: 'enableDataSourceSharing',
    DISABLE_SHARING: 'disableSharing',
    DISABLE_COPY_LINK: 'disableCopyLink',
    DISABLE_FEEDBACK: 'disableFeedback',
    MAX_NUM_DEFAULT_PINBOARD: 'maxNumDefaultPinboard',
    ENABLE_PENDO: 'enablePendo',
    ENABLE_PENDO_HELP: 'enablePendoHelp',
    REQUEST_ACCESS_CONFIG: 'requestAccessConfiguration',
    OBJECT_REQUEST_ACCESS_LEVEL: 'objectRequestAccessLevel',
    DATASOURCE_REQUEST_ACCESS_LEVEL: 'dataSourceRequestAccessLevel',
    EMAIL_CONFIG: 'emailConfig',
    WELCOME_EMAIL_CONFIG: 'welcomeEmailConfig',
    WELCOME_EMAIL_ENABLED: 'enabled',
    EMAIL_PRODUCT_NAME: 'productName',
    IS_FIRST_LOGIN: 'isFirstLogin',
    USER_TYPE_KEY: 'userType',
    FIRST_LOGIN_DATE: 'firstLoginDate',
    DISABLE_WELCOME_EMAIL: 'disableWelcomeEmail',
    SUPOORT_EMAIL: 'supportEmail',
    USER_EMAIL: 'userEmail',
    CLUSTER_TYPE: 'clusterType',
    PRODUCT_TYPE: 'productType',
    ENABLE_SIGNUP_BTN: 'signUpEnabled',
    SIGNUP_BTN_TEXT: 'signUpButtonText',
    SIGNUP_BTN_LINK: 'signUpButtonLink',
    IS_DARK_CLUSTER: 'isDarkCluster',
    IS_EMBEDDED_USECASE: 'isEmbeddedUseCase',
    IS_EVERYWHERE_ENABLED: 'isEverywhereEnabled',
    ENABLE_SELECTIVE_USER_ACCESS_RESTRICTION: 'enableSelectiveUserAccessRestriction',
    IS_EVERYWHERE_SETTING_LOCKED: 'embedSettingsLockedEnabled',
    ENABLE_MINIMUM_BAR_HEIGHT: 'enableMinimumBarHeight',
    ENABLE_GRIDLINES: 'enableGridlines',
    SHOW_CHART_APPLY_AND_RESET_BUTTONS: 'showChartApplyandResetButtons',
    APPLY_CONTRAST_FOR_DATALABELS: 'applyContrastForDataLabels',
    ENABLE_ATTRIBUTES_IN_PIVOT_DATA_AREA: 'enableAttributesInPivotDataArea',
    IS_TSE_SCHEDULER_FEATURE_ENABLED: 'tseScheduleFeatureEnabled',
    IS_TSE_MULTIPLE_APP_ACTION_ENABLED: 'tseMultipleAppActionEnabled',
    IS_TSE_STYLE_CUSTOMISATIONS_V2_ENABLED: 'tseStyleCustomisationsV2Enabled',
    TSE_V2_STYLE_APIS_ENABLED: 'tseV2StyleApisEnabled',
    IS_TSE_REST_API_2_0_PLAYGROUND_ENABLED: 'tseRestApiV2PlaygroundEnabled',
    TSE_SCHEDULER_SERVICE_CLIENT_ID: 'tseClientId',
    IS_PUBLIC_USER: 'isPublicUser',
    PUBLIC_USER_NAME: 'publicUserName',
    DOC_HIDDEN_DEVELOP_TAB: 'docHiddenInDevelopTab',
    RESET_PASSWORD_ENABLED: 'resetPasswordEnabled',
    CUSTOM_CALENDAR_CONFIG: 'customCalendarConfig',
    CUSTOM_CALENDAR_ENABLED: 'enabled',
    EMBRACE_CONFIG: 'embraceConfig',
    ENABLE_CUSTOM_CAL_DATABASE_LIST: 'enableCustomCalDatabaseList',
    DATABASES_WITH_CSV_UPLOAD_ENABLED: 'databasesWithCsvUploadEnabled',
    EXCLUDE_CUSTOM_SQL_DATABASES_LIST: 'excludeCustomSqlDatabasesList',
    DATABASES_WITH_OAUTH_ENABLED_LIST: 'databasesWithOauthEnabled',
    DATABASES_WITH_EXTERNAL_OAUTH_ENABLED_LIST: 'databasesWithExtOauthEnabled',
    SEARCH_CACHE_ENABLED_DATASOURCES: 'searchCacheEnabledDatasources',
    EMBRACE_ENABLED: 'enabled',
    INTERCOM_ENABLED: 'intercomEnabled',
    ISDATAFLOWENABALED: 'isDataFlowEnabled',
    DATABASE_MODE: 'databaseMode',
    ENABLE_COLUMN_SUMMARIES_BY_DEFAULT: 'enableColumnSummariesByDefault',
    ENABLE_SUMMARIES_CUSTOM_FORMAT_BY_DEFAULT: 'enableSummariesCustomFormatByDefault',
    DISABLE_QUESTION_ANSWER_HEADLINE_QUERIES: 'disableQuestionAnswerHeadlineQueries',
    SOURCE_TOGGLE_ENABLED: 'sourceToggleEnabled',
    SHOW_EMBRACE_STATS: 'showEmbraceStats',
    FEDERATED_USER: 'FEDERATION',
    SOCIAL_USER: 'SOCIAL',
    IS_SYNC_ENABLED: 'isSyncEnabled',
    ENABLE_WKS_VIEWER: 'enableSchemaViewer',
    ENABLE_BYPASS_RLS_PRIVILEGE: 'enableBypassRLSPrivilege',
    DISABLE_ANSWER: 'disableAnswer',
    OIDC_CONFIG: 'oidcConfiguration',
    ORG_DELIMITER: 'oidcOrgDelimeter',
    SCIM_CONFIG: 'scimConfig',
    SCIM_BASE_URL: 'scimBaseUrl',
    OIDC_ENABLED: 'iamV2OIDCEnabled',
    MFA_ENABLED: 'multiFactorAuthEnabled',
    MFA_BANNER_UI_ENABLED: 'mfaBannerUIEnabled',
    MFA_ACCEPTED: 'mfaAccepted',
    JWT_TOKEN_FEATURE_ENABLED: 'jwTokenFeatureEnabled',
    MANDATORY_TOKEN_FILTER_FEATURE_ENABLED: 'mandatoryTokenFilterFeatureEnabled',
    ANALYST_STUDIO_APP_ID: 'AnalystStudio',
    ANALYST_STUDIO_ENABLED: 'analystStudioEnabled',
    FOLDERS_ENABLED: 'foldersEnabled',
    AGENT_SPOT_ENABLED: 'agentSpotEnabled',
    AGENT_SPOT_CONFIG: 'agentSpotConfig',
    AGENT_SPOT_URL: 'agentSpotUrl',
    COLLECTIONS_PRIVILEGE_ENABLED: 'collectionsPrivilegeEnabled',
    SCIM_PER_ORG_ENABLED: 'scimPerOrgEnabled',
    ANALYST_STUDIO_CONFIG: 'analystStudioConfig',
    PRINCIPAL_TYPE_IMPORT_EXPORT: 'principalTypeTmlImportExportEnabled',
    SYNC_USERS_GROUPS_AND_ORGS: 'syncUserGroupsAndOrgsFromOIDC',
    OIDC_CONFIGURATION_ENABLED: 'enabled',
    GROUPS_WTIH_ORGS_ENABLED: 'syncUserGroupsAndOrgsFromOIDC',
    FULL_EMBED_CONFIG: 'fullEmbedConfiguration',
    PINBOARD_CREATION_PRIVILEGE_ENABLED: 'pinboardCreationPrivilegeEnabled',
    VIZ_EMBED_CONFIG: 'vizEmbedConfiguration',
    ENABLE_WORKSHEET_OVER_AGGR_WKS: 'enableWorksheetOverAggrWorksheet',
    ENABLE_AGGR_WKS_TABLE_JOIN: 'enableAggrWsTableJoin',
    PRIMARY_NAV_HIDDEN: 'primaryNavHidden',
    PROFILE_AND_HELP_OPTIONS_IN_NAV_BAR_HIDDEN: 'profileAndHelpOptionsInNavBarHidden',
    APPLICATION_SWITCHER_HIDDEN: 'applicationSwitcherHidden',
    ORG_SWITCHER_HIDDEN: 'orgSwitcherHidden',
    SHOW_ORG_SWITCHER_TO_USERS_WITH_MULTIPLE_ORGS: 'showOrgSwitcherToUsersWithMultipleOrgs',
    ALERT_BAR_HIDDEN: 'alertBarHidden',
    SHOULD_SKIP_ADD_USER_TO_MODE: 'shouldSkipAddUserToMode',
    DISABLE_TRANSFORMATIONS: 'disableTransformations',
    POWERED_FOOTER_HIDDEN: 'poweredFooterHidden',
    SCHEDULE_REPORTING_CONFIG: 'scheduledReportingConfig',
    SLACK_BOT_CONFIG: 'slackBotConfiguration',
    SCHEDULE_REPORTING_ENABLED: 'enabled',
    EXPORT_CONFIG: 'exportConfig',
    BACH_CONFIG: 'bachConfig',
    USE_SAGE_ADD_FILTER_V2_API: 'useSageAddFilterV2Api',
    ZOOMED_RENDER_WIDTH_FOR_EXPORT: 'zoomedRenderWidthForExport',
    ZOOMED_RENDER_WIDTH_FOR_EXPORT_V2: 'zoomedRenderWidthForExportV2',
    ENABLE_MULTI_WORKSHEET: 'enableMultiWorksheet',
    IS_LIVEBOARD_TAB_EXPORT_ENABLED: 'isLiveboardTabExportEnabled',
    MAX_VIZ_IN_TAB_FOR_EXPORT: 'maxVizInTabForExport',
    A3_CONFIG: 'a3Config',
    A3_ENABLED: 'a3LiveDataAnalysisEnabled',
    CUSTOM_R_ANALYSIS: 'customRAnalysis',
    THIRDPARTY_ANALYSIS_ENABLED: 'thirdPartyAnalysisEnabled',
    CUSTOM_BRANDING_ENABLED: 'customBrandingEnabled',
    RESTRICT_CUSTOM_R_TO_ADMINS: 'restrictCustomRToAdmins',
    HELP_MENU_COMMUNITY_AND_REPLAY_OPTIONS_HIDDEN: 'helpMenuCommunityAndReplayOptionsHidden',
    ASK_EXPERT_ENABLED: 'enabled',
    CURRENT_ORG_EMBED_URLS_KEY: 'currentOrgEmbedUrls',
    EMBED_URLS_KEY: 'embedUrls',
    ENABLE_DELAYED_SEARCH: 'enableDelayedSearch',
    ENABLE_SNAPSHOT_CAPTURE: 'enableSnapshotCapture',
    ENABLE_SNAPSHOT_CAPTURE_ANSWER_V2: 'enableSnapshotCaptureForAnswerV2',
    ENABLE_EUREKA_ADVANCED_TYPEAHEAD: 'enableEurekaAdvancedTypeahead',
    ENABLE_EUREKA_DEBUG_INFO: 'enableEurekaDebugInfo',
    ENABLE_EUREKA_TYPEAHEAD_RECENT_OBJECTS: 'enableEurekaTypeaheadRecentObjects',
    DISCOVERABILITY_CHECKBOX_UNSELECTED_PER_ORG: 'discoverabilityCheckboxUnselectedPerOrg',
    DISCOVERABILITY_CHECKBOX_UNSELECTED_NON_ORG: 'discoverabilityCheckboxUnselected',
    EDGE_ONBOARDING_COMPLETED: 'edgeOnboardingCompleted',
    EDGE_ONBOARDING_PERSONAL_INFO_FILLED: 'edgeOnboardingPersonalInfoFilled',
    EDGE_ONBOARDING_INTRO_VIDEO_SEEN: 'edgeOnboardingIntroVideoSeen',
    SPARK_FLOW_CONFIG: 'sparkFlowConfig',
    SPARK_FLOW_ENABLED: 'isSparkFlowEnabled',
    IS_FROM_SPARKFLOW: 'isFromSparkflow',
    ENABLE_USECASE_BASED_ONBOARDING: 'enableUsecaseBasedOnboarding',
    ENABLE_SPARKFLOW_V2: 'enableSparkflowV2',
    ENABLE_ONBOARDING_QUESTION_CHIPS: 'enableOnboardingQuestionChips',
    ENABLE_ONBOARDING_CSV_UPLOAD: 'enableOnboardingCSVUpload',
    SHOW_SPARKFLOW_TRIAL_BANNER_IN_LIVEBOARD_EDIT_PAGE: 'showTrialBannerInLiveboardEditPage',
    ENABLE_FULL_USER_JOURNEY: 'enableFullUserJourney',
    SKIP_FREE_TRIAL_ONBOARDING_STEPS: 'skipFreeTrialOnboardingSteps',
    ONBOARDING_LOCATION_SELECTED: 'onboardingLocationSelected',
    ENABLE_EUREKA_SEARCH: 'enableEurekaSearch',
    ENABLE_EUREKA_SEARCH_DEDUPLICATION: 'enableEurekaSearchDeduplication',
    ENABLE_EUREKA_WORKSHEET_DISABLEMENT: 'enableEurekaWorksheetDisablement',
    ENABLE_EDGE: 'edgeEnabled',
    ENABLE_COPILOT: 'copilotEnabled',
    ENABLE_TSE_V2_EXPERIENCE: 'enableTSEV2Experience',
    ENABLE_FREE_TRIAL_V2_EXPERIENCE: 'enableFreeTrialV2Experience',
    ENABLE_TEAMS_ADMIN_TAB: 'enableTeamsAdminTab',
    ENABLE_REGISTER_AMA_BUTTON: 'enableRegisterAMAButton',
    ENABLE_STATUS_PAGE: 'statusPageEnabled',
    ENABLE_ENHANCED_USER_EMAIL_VALIDATION: 'enhancedUserEmailValidationEnabled',
    ENABLE_EUREKA_SYNONYM_WORKFLOW: 'enableEurekaSynonymWorkflow',
    ENABLE_EXPLORE_MEASURE_FILTERS: 'exploreMeasureFiltersEnabled',
    ENABLE_CUSTOM_R_IN_SEARCH_PAGE: 'enableCustomRInSearchPage',
    ENABLE_SEASONALITY_DETECTION: 'enableSeasonalityDetection',
    ENABLE_ANOMALY_EXPLANATION: 'enableAnomalyExplanation',
    ENABLE_FOLLOW_FEATURE: 'enableFollowFeature',
    ENABLE_FOLLOW_V2: 'enableFollowV2',
    ENABLE_HEADLINE_PINNING: 'enableHeadlinePinning',
    ENABLE_CUSTOM_COMPARISON_ON_CHART: 'enableCustomComparisonOnChart',
    ENABLE_ADDITIONAL_INSIGHTS: 'enableAdditionalInsights',
    ENABLE_CCA_SUMMARY_TAB: 'enableCCASummaryTab',
    ENABLE_CHANGE_ANALYSIS_BY_MEASURE: 'enableChangeAnalysisByMeasure',
    ENABLE_GENERIC_CUSTOM_COMPARE: 'enableGenericCustomCompare',
    ENABLE_ANALYZE_BUTTON: 'enableAnalyzeButton',
    INSTANT_INSIGHTS_FEEDBACK_ENABLED: 'instantInsightsFeedbackEnabled',
    INSTANT_INSIGHTS_ANALYSIS_DEPTH: 'instantInsightsAnalysisDepth',
    RELATED_TABLE_INSIGHTS_ANALYSIS_DEPTH: 'relatedTableInsightsAnalysisDepth',
    EXECUTIVE_SUMMARY_LEVEL: 'executiveSummaryLevel',
    PINBOARD_INSIGHTS_TIMEOUT_IN_SECONDS: 'pinboardInsightsTimeoutInSeconds',
    HOMEPAGE_INSIGHTS_ENABLED: 'homepageInsightsEnabled',
    PINBOARD_SPOTIQ_SNAPSHOT_ENABLED: 'pinboardSpotiqSnapshotEnabled',
    ANSWER_SPOTIQ_SNAPSHOT_ENABLED: 'answerSpotiqSnapshotEnabled',
    RELATED_QUERIES_ENABLED: 'relatedQueriesEnabled',
    EMPTY_SEARCH_PAGE_INSIGHTS_ENABLED: 'emptySearchPageInsightsEnabled',
    SEARCH_PAGE_INSIGHTS_ENABLED: 'instantInsightsOnSearchPageEnabled',
    INLINE_AUTO_ANALYSIS_ENABLED: 'inlineAutoAnalysisEnabled',
    MAX_PER_USER_SUBSCRIPTION: 'maxPerUserSubscription',
    A3_PINBOARD_EXPIRY_IN_SECONDS: 'a3PinboardExpiryInSeconds',
    A3_INSIGHT_KEY: 'insightKey',
    REQUEST_TYPE: 'requestType',
    LEARN_PINBOARD_ID: 'learnPinboardId',
    PINBOARD_TABLE_DATA_BATCH_SIZE: 'maxPinboardTableDataBatchSize',
    DEFAULT_CHART_DATA_SIZE: 'defaultChartDataSize',
    HIGH_CARDINALITY_MAX_DATA_SIZE: 'highCardinalityMaxDataSize',
    CUSTOM_CHART_ROWS_LIMIT: 'customChartRowsLimit',
    IS_CJA_ENABLED: 'enableCJA',
    ENABLE_GLOBAL_NAV: 'enableGlobalNav',
    IS_DISCOVERABILITY_ENABLED: 'enableLenientContentDiscoverability',
    FETCH_PIVOT_SUMMARY_FROM_BACKEND: 'fetchPivotSummaryFromBackend',
    VIZ_RENDERING_QUEUE_TIMEOUT_MS: 'vizRenderingQueueTimeoutMS',
    ENABLE_HIGHCHARTS_WARMUP: 'enableHighchartsWarmup',
    TABLE_PRINT_DATA_BATCH_SIZE: 'tablePrintDataBatchSize',
    IS_XLSX_SCHEDULE_ENABLED: 'isXlsxScheduleEnabled',
    INSTALLED_SCHEMA_VERSION: 'installedSchemaVersion',
    CUSTOMER_ADMIN_EMAIL: 'customerAdminEmail',
    CUSTOMER_ADMIN_PHONE_NUMBER: 'customerAdminPhoneNumber',
    DISABLE_ANSWER_DISPLAY_MODE_PREFERENCE: 'disableAnswerDisplayModePreference',
    ENABLE_STYLE_CUSTOMIZATION: 'customBrandingEnabled',
    ENABLE_FONT_STYLE_CUSTOMIZATION: 'customBrandingFontCustomizationEnabled',
    ENABLE_FOOLSCAP_PDF_DOWNLOAD: 'foolscapPdfDownloadEnabled',
    ENABLE_METADATA_MIGRATION: 'metadataMigrationEnabled',
    ANSWER_V2_EXPERIENCE: 'answerV2Experience',
    IS_ANSWER_V2_ON_BY_DEFAULT: 'isAnswerV2OnByDefault',
    HOME_V2_EXPERIENCE: 'homeV2Experience',
    ACTIONS_USER_GROUPS_ENABLED: 'actionsUserGroupsEnabled',
    USE_LEGACY_EMBEDDED_PINBOARD_ACTION_CONFIG: 'useLegacyEmbeddedPinboardActionConfig',
    URL_FLAGS_DISABLED: 'isURLFlagDisabled',
    ENABLE_INSTANT_SEARCH: 'enableInstantSearch',
    ENABLE_PARAMETERS: 'enableParameters',
    ENABLE_COHORTS: 'enableCohorts',
    ENABLE_DATA_PANEL_V2: 'enableDataPanelV2',
    ENABLE_DOUBLE_CLICK_DRILL_DOWN: 'enableDoubleClickDrillDown',
    LIST_SEARCH_DEBOUNCING_IN_MS: 'listSearchDebouncingInMS',
    EXPOSED_USER_PREFERENCES_KEY: 'userPreferences',
    USER_PREFERENCES_PROTO_KEY: 'preferenceProto',
    PREFERRED_LOCALE_KEY: 'preferredLocale',
    LAST_SEEN_LOCALE_KEY: 'lastSeenLocale',
    enableOnboardingConfigPerOrg: 'enableOnboardingConfigPerOrg',
    LOCALE: 'locale',
    USER_SLACK_ID: 'slackId',
    USE_CUSTOM_EMBED_URLS_KEY: 'useCustomEmbedUrls',
    CALENDARS_KEY: 'calendars',
    DEFAULT_CALENDAR_KEY: 'default',
    CALENDAR_QUARTER_START_MONTH_KEY: 'quarterStartMonth',
    CLIENT_STATE_ANSWER_MODE_KEY: 'answerMode',
    CLIENT_STATE_VIZ_SELECTION_ANSWER_MODE_KEY: 'vizSelectionAnswerMode',
    INFORMATICA_CONFIG: 'informaticaCloudConfig',
    INFORMATICA_EXPRESSION_ASSISTANT: 'expressionAssistantUrl',
    USE_TIMELY_SCHEDULING: 'useTimelyForScheduling',
    ACCEPT_LANGUAGE_CONFIG_KEY: 'acceptLanguage',
    CAN_CHANGE_PASSWORD: 'canChangePassword',
    ENABLE_MAP_TILES_CONFIG_KEY: 'enableMapTiles',
    GEO_TILE_SOURCE_ID: 'geoTileSourceId',
    GEO_TILE_TYPE: 'geoTileType',
    MAPBOX_ACCESS_TOKEN: 'mapboxAccessToken',
    GEO_MAP_CONFIG_KEY: 'geoMapConfig',
    DATA_BATCH_SIZE_KEY: 'dataBatchSize',
    MAX_CONCURRENT_DATA_CALLS: 'maxConcurrentDataCalls',
    samlConfig: {
        SAML_CONFIG: 'samlConfiguration',
        SAML_ENABLED: 'samlEnabled',
        SAML_LOGIN_PAGE_REDIRECT: 'samlLoginPageRedirect',
        LOGOUT_ENABLED: 'logoutEnabledInUI',
    },
    SEARCH_ASSIST_ENABLED: 'enableSearchAssist',
    SHOW_UPGRADE_OPTIONS: 'highlightProFeatures',
    SHOW_REDESIGNED_HOMEPAGE: 'redesignedHomepage',
    ENABLE_ORGS_FT_PHASE_2: 'enableOrgsOnFTPhase2',
    USER_LIMIT_ALERT_ENABLED_TE: 'userLimitAlertEnabledForTE',
    EMBRACE_V2_EXPERIENCE: 'embracev2Experience',
    NEW_CONNECTIONS_EXPERIENCE: 'newConnectionsExperience',
    CONNECTORS_CATEGORIZATION_ENABLED: 'connectorsCategorizationEnabled',
    ENABLE_DATAWORKSPACE_TABLE_V2: 'enableDataWorkspaceTableV2',
    SQL_EDITOR_AUTO_COMPLETE_ENABLED: 'isSqlEditorAutoCompleteEnabled',
    SINGLE_WINDOW_OAUTH_ENABLED: 'singleWindowOAuthEnabled',
    CONNECTION_PAYLOAD_RESTRUCTURING_ENABLED: 'connectionPayloadRestructuringEnabled',
    REMAPPING_V2_EXPERIENCE: 'remappingV2Experience',
    IS_OAUTH_AUTO_REDIRECT_ENABLED: 'isOauthAutoRedirectEnabled',
    ENABLE_CONNECTION_SHARING_V2_APIS: 'enableConnectionSharingV2Apis',
    VALUE_CASING_COLUMN_WORKSHEET: 'useColumnValueCasing',
    TABLE_JOIN_V2_ENABLED: 'tableJoinV2Enabled',
    ENABLE_DELETE_DEPENDENT_JOIN: 'enableDeleteDependentJoin',
    UPDATED_JOINS_UI_ENABLED: 'updatedJoinsUIEnabled',
    RESTRICT_SEARCH_HELP: 'restrictSearchHelp',
    DEFAULT_FILTER_NON_CASCADING: 'defaultFilterNonCascading',
    OPEN_VIZ_URL_IN_SAME_TAB: 'openVizUrlInSameTab',
    PINBOARD_FILTER_CONFIGURATOR_DISABLED: 'pinboardFilterConfiguratorDisabled',
    FIRST_PIN_EXPERIENCE_ENABLED: 'firstPinExperienceEnabled',
    MULTIPLE_DEMO_DATASETS_ENABLED: 'isMultipleDemoDataSetsEnabled',
    SYNONYM_GENERATION_ENABLED: 'synonymGenerationEnabled',
    AUTO_GENERATE_SYNONYMS_ON_SAVE: 'autoGenerateSynonymsOnSave',
    FREE_TRIAL_ONBOARDING_SEEN: 'freeTrialOnboardingSeen',
    ENABLE_OPTIMIZED_PAYLOAD_STRUCTURE: 'enableOptimizedPayloadStructure',
    PINS_FLOW_SEEN: 'pinsFlowSeen',
    PINS_SPOTLIGHT_SEEN: 'pinsSpotlightSeen',
    FIRST_PIN_EXPERIENCE: 'firstPinExperience',
    IDENTITY_SERVICE_PUBLIC_URL: 'identityServicePublicUrl',
    IDENTITY_SERVICE_URL: 'identityServiceUrl',
    IDENTITY_DOMAIN: 'identityDomain',
    IS_LIVEBOARD_ENABLED: 'isLiveboardEnabled',
    SEMANTIC_INTEGRATION_ENABLED: 'semanticIntegrationEnabled',
    TRIAL_VERSION_CONFIG_KEY: 'trialVersionConfig',
    TRIAL_ENABLED_KEY: 'enableTrialVersion',
    TRIAL_ACCOUNT_LIFE_DAYS: 'trialAccountLifeDays',
    TRIAL_USER_EXPIRATION_TIME: 'userExpirationTime',
    EXPIRED_ACCOUNT_LIFE_DAYS: 'expiredAccountLifeDays',
    TRIAL_CLUSTER_QUALIFIED_URL: 'trialClusterQualifiedUrl',
    SAGE_OUTPUT_COLUMN_ID_KEY: 'sageOutputColumnId',
    OUTPUT_IDS_WITH_MATCHING_LOGICAL_KEY: 'outputIdsWithMatchingLogicalKey',
    EFFECTIVE_COLUMN_ID_KEY: 'effectiveColumnGuid',
    VIZ_TYPE_PINBOARD: 'pinboard_viz',
    VIZ_TYPE_CHART: 'chart',
    VIZ_TYPE_HEADLINE: 'headline',
    VIZ_TYPE_TABLE: 'table',
    VIZ_TYPE_FILTER: 'filter',
    VIZ_TYPE_GENERIC: 'generic_viz',
    VIZ_TYPE_CLUSTER: 'CLUSTER_VIZ',
    VIZ_TYPE_R_ANALYSIS: 'r_analysis',
    VIZ_TITLE_KEY: 'title',
    VIZ_NAME_KEY: 'name',
    VALUE_KEY: 'value',
    VALUES_KEY: 'values',
    TEXT_KEY: 'text',
    MAIL_KEY: 'mail',
    LAYOUT_TILE_STATE_STANDARD: 'standard',
    LAYOUT_TILE_STATE_EXPANDED: 'expanded',
    ENLITE_ENABLED: 'enliteEnabled',
    ENLITE_PRIVILEGED: 'enlitePrivileged',
    ENLITE_METRICS_DISABLED: 'enliteMetricsDisabled',
    GLOBALLY_TRENDING: 'globallyTrending',
    RECENTLY_TRENDING: 'recentlyTrending',
    RECENTLY_VIEWED: 'objects',
    LOGICAL_TABLE_METADATA_KEY: 'tableMetadata',
    LOGICAL_TABLE_CONTENT_KEY: 'logicalTableContent',
    LOGICAL_TABLE_DATA_KEY: 'tableData',
    LOGICAL_TABLE_JOIN_TYPE: 'joinType',
    LOGICAL_TABLE_JOIN_TYPE_OVERRIDES: 'joinTypeOverrides',
    LOGICAL_TABLE_JOIN_OVERRIDES: 'joinOverrides',
    LOGICAL_TABLE_IS_OPTIMIZED: 'isOptimized',
    LOGICAL_TABLE_IS_ONE_TO_ONE: 'isOneToOneJoin',
    LOGICAL_TABLE_BYPASS_RLS: 'bypassRLS',
    WORKSHEET_TYPE: 'worksheetType',
    DEFAULT_DATA_SOURCE: 'Default',
    COMPLETE: 'complete',
    INCOMPLETE_DETAIL: 'incompleteDetail',
    AUTO_FORMAT_COLUMN_NAMES: 'autoFormatColumnNames',
    GROWTH_KEY: 'growth',
    GROUP_BY_KEY: 'groupBy',
    MAX_SEARCH_IQ_PREFERRED_COLUMNS: 'maxNumSearchIQPreferredColumnsAllowed',
    MAX_SEARCH_IQ_PREFERRED_DATE_COLUMNS: 'maxNumSearchIQPreferredDateColumnsAllowed',
    queryJoinType: {
        INNER: 'INNER',
        LEFT_OUTER: 'LEFT_OUTER',
        RIGHT_OUTER: 'RIGHT_OUTER',
        FULL_OUTER: 'OUTER',
    },
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CsvUploadEntryPoints: {
        Falcon: {
            EmbraceConnectionsWizard: 'embraceConnectionsWizard',
            Utilities: 'utilities',
            ConnectionsHomepage: 'connectionsHomepage',
            SetupHub: 'setupHub',
            TableListPage: 'tableListPage',
            EdgeOnboarding: 'edge',
            createConnectionCustomSourceEdge: 'createConnectionCustomSourceEdge',
        },
        Embrace: {
            Utilities: 'utilities',
        },
    },
    worksheetType: {
        CONTAINER: 'CONTAINER',
        VIEW: 'VIEW',
    },
    WorksheetConstants: {
        V1: 'V1',
        V2: 'V2',
        WORKSHEET: 'Worksheet',
        MODEL: 'Model',
    },
    COLUMN_GEO_RESTRICTIONS: 'columnGeoRestrictions',
    COMPOUND_INDICES_KEY: 'compoundRowIndices',
    TABLE_PAGE: 'table',
    WORKSHEET_PAGE: 'worksheet',
    VIEW_PAGE: 'view',
    IS_DERIVED_KEY: 'isDerived',
    DERIVATION_EXPRESSION: 'derivationExpr',
    DERIVATION_EXPR_TYPE: 'exprType',
    SOURCES_NODE_KEY: 'sources',
    LOGIN_CONFIG: 'loginConfig',
    PASSWORD_CONFIG: 'passwordConfig',
    PASSWORD_HISTORY_SIZE_KEY: 'passwordHistorySize',
    PASSWORD_STRATEGY_KEY: 'passwordStrategy',
    BLACK_LISTED_WORDS: 'blacklistedWords',
    metadataTypeSort: {
        AUTHOR: 'AUTHOR',
        CREATED: 'CREATED',
        DEFAULT: 'DEFAULT',
        MODIFIED: 'MODIFIED',
        MATERIALIZED: 'MATERIALIZED',
        NAME: 'NAME',
        DISPLAY_NAME: 'DISPLAY_NAME',
        STATUS: 'STATUS',
        USER_STATE: 'USER_STATE',
    },
    timelyJob: {
        NAME: 'name',
        CREATION_TIME: 'creation_time',
        LAST_MODIFICATION_TIME: 'last_modification_time',
    },
    pinboardType: {
        LEARN: 'LEARN',
        ADMIN: 'ADMIN',
        INSIGHT: 'INSIGHT',
        EMBED: 'EMBED',
        DEFAULT: 'DEFAULT',
        UNKNOWN: 'UNKNOWN',
    },
    materialize: {
        STATUS: 'status',
        LAST_REFRESH_TIME: 'lastRefreshTime',
    },
    metadataType: {
        LOGICAL_TABLE: 'LOGICAL_TABLE',
        RLS_RULE: 'RLS_RULE',
        INSIGHT: 'INSIGHT',
        LOGICAL_COLUMN: 'LOGICAL_COLUMN',
        ROLES: 'ROLE',
        LOGICAL_RELATIONSHIP: 'LOGICAL_RELATIONSHIP',
        IMPORTED_DATA: 'USER_DATA',
        QUESTION_ANSWER_BOOK: 'QUESTION_ANSWER_BOOK',
        DATA_SOURCE: 'DATA_SOURCE',
        CONNECTION: 'CONNECTION',
        REPORT_BOOK: 'REPORT_BOOK',
        PINBOARD_ANSWER_BOOK: 'PINBOARD_ANSWER_BOOK',
        TAG: 'TAG',
        VISUALIZATION: 'VISUALIZATION',
        TABLE_FILTER: 'TABLE_FILTER',
        USER: 'USER',
        GROUP: 'USER_GROUP',
        ROLE: 'USER_ROLE',
        RELATED_LINK: 'RELATED_LINK',
        R_TEMPLATE: 'R_TEMPLATE',
        USER_QUESTION: 'USER_QUESTION',
        USER_GROUP: 'GROUP',
        FEEDBACK: 'FEEDBACK',
        COLUMN_ALIAS_UDF: 'COLUMN_ALIAS_UDF',
        ANALYSIS_RESULT: 'ANALYSIS_RESULT',
        COLUMN_SECURITY_RULES: 'COLUMN_SECURITY_RULES',
        subType: {
            WORKSHEET: 'WORKSHEET',
            MODEL: 'MODEL',
            PRIVATE_WORKSHEET: 'PRIVATE_WORKSHEET',
            IMPORTED_DATA: 'USER_DEFINED',
            SYSTEM_TABLE: 'ONE_TO_ONE_LOGICAL',
            DB_VIEW: 'DB_VIEW',
            VIEW: 'AGGR_WORKSHEET',
            USER_DEFINED: 'USER_DEFINED',
            SQL_VIEW: 'SQL_VIEW',
            LESSON_PLAN: 'LESSON_PLAN',
            SAGE_VIEW: 'AGGR_WORKSHEET',
            ONE_TO_ONE_LOGICAL: 'ONE_TO_ONE_LOGICAL',
            INPUT_TABLE: 'INPUT_TABLE',
            DATASET: 'DATASET',
        },
        synonymTypes: {
            AUTO_GENERATED: 'AUTO_GENERATED',
            USER_DEFINED: 'USER_DEFINED',
            UNKNOWN: 'UNKNOWN',
        },
        AI_CONTEXT: 'AI_CONTEXT',
        FILTER: 'FILTER',
        commonTypes: {
            ANSWER: 'ANSWER',
            PINBOARD: 'PINBOARD',
            LIVEBOARD: 'LIVEBOARD',
            VIEW: 'VIEW',
            SQL_VIEW: 'SQL_VIEW',
            WORKSHEET: 'WORKSHEET',
            MODEL: 'MODEL',
            TABLE: 'TABLE',
        },
        DESTINATION: 'DESTINATION',
        MONITOR_ALERTS: 'MONITOR_ALERTS',
        DBT_CONNECTION: 'DBT_CONNECTION',
        COHORT: 'COHORT',
        COLLECTION: 'COLLECTION',
        SEMANTIC_INTEGRATION: 'SEMANTIC_INTEGRATION',
        metaDataTypesWithoutALink: ['COHORT'],
    },
    privilegeType: {
        ADMINISTRATION: 'ADMINISTRATION',
        DEVELOPER: 'DEVELOPER',
        AUTHORING: 'AUTHORING',
        USERDATAUPLOADING: 'USERDATAUPLOADING',
        DATADOWNLOADING: 'DATADOWNLOADING',
        SHAREWITHALL: 'SHAREWITHALL',
        DATAMANAGEMENT: 'DATAMANAGEMENT',
        JOBSCHEDULING: 'JOBSCHEDULING',
        A3ANALYSIS: 'A3ANALYSIS',
        BYPASSRLS: 'BYPASSRLS',
        EXPERIMENTALFEATUREPRIVILEGE: 'EXPERIMENTALFEATUREPRIVILEGE',
        RANALYSIS: 'RANALYSIS',
        DISABLE_PINBOARD_CREATION: 'DISABLE_PINBOARD_CREATION',
        APPLICATION_ADMINISTRATION: 'APPLICATION_ADMINISTRATION',
        USER_ADMINISTRATION: 'USER_ADMINISTRATION',
        GROUP_ADMINISTRATION: 'GROUP_ADMINISTRATION',
        BACKUP_ADMINISTRATION: 'BACKUP_ADMINISTRATION',
        SYSTEM_INFO_ADMINISTRATION: 'SYSTEM_INFO_ADMINISTRATION',
        ENABLESPOTAPPCREATION: 'ENABLESPOTAPPCREATION',
        SYNCMANAGEMENT: 'SYNCMANAGEMENT',
        CAN_CREATE_CATALOG: 'CAN_CREATE_CATALOG',
        LIVEBOARD_VERIFIER: 'LIVEBOARD_VERIFIER',
        ROLE_ADMINISTRATION: 'ROLE_ADMINISTRATION',
        ORG_ADMINISTRATION: 'ORG_ADMINISTRATION',
        AUTHENTICATION_ADMINISTRATION: 'AUTHENTICATION_ADMINISTRATION',
        BILLING_INFO_ADMINISTRATION: 'BILLING_INFO_ADMINISTRATION',
        PREVIEW_THOUGHTSPOT_SAGE: 'PREVIEW_THOUGHTSPOT_SAGE',
        CSV_UPLOAD_MODE: 'CSV_UPLOAD_MODE',
        CAN_MANAGE_CUSTOM_CALENDAR: 'CAN_MANAGE_CUSTOM_CALENDAR',
        CAN_CREATE_OR_EDIT_CONNECTIONS: 'CAN_CREATE_OR_EDIT_CONNECTIONS',
        CONTROL_TRUSTED_AUTH: 'CONTROL_TRUSTED_AUTH',
        CAN_MANAGE_WORKSHEET_VIEWS_TABLES: 'CAN_MANAGE_WORKSHEET_VIEWS_TABLES',
        TAGMANAGEMENT: 'TAGMANAGEMENT',
        CAN_MANAGE_VERSION_CONTROL: 'CAN_MANAGE_VERSION_CONTROL',
        CAN_SETUP_VERSION_CONTROL: 'CAN_SETUP_VERSION_CONTROL',
        THIRDPARTY_ANALYSIS: 'THIRDPARTY_ANALYSIS',
        ALLOW_NON_EMBED_FULL_APP_ACCESS: 'ALLOW_NON_EMBED_FULL_APP_ACCESS',
        CAN_ACCESS_ANALYST_STUDIO: 'CAN_ACCESS_ANALYST_STUDIO',
        CAN_MANAGE_ANALYST_STUDIO: 'CAN_MANAGE_ANALYST_STUDIO',
        CAN_MODIFY_FOLDERS: 'CAN_MODIFY_FOLDERS',
        CAN_MANAGE_VARIABLES: 'CAN_MANAGE_VARIABLES',
        CAN_VIEW_FOLDERS: 'CAN_VIEW_FOLDERS',
        CAN_MANAGE_WEBHOOKS: 'CAN_MANAGE_WEBHOOKS',
        CAN_DOWNLOAD_DETAILED_DATA: 'CAN_DOWNLOAD_DETAILED_DATA',
        CAN_DOWNLOAD_VISUALS: 'CAN_DOWNLOAD_VISUALS',
        CAN_USE_SPOTTER: 'CAN_USE_SPOTTER',
        CAN_MANAGE_SPOTTER: 'CAN_MANAGE_SPOTTER',
        CAN_MANAGE_AGENTSPOT: 'CAN_MANAGE_AGENTSPOT',
        CAN_ACCESS_AGENTSPOT: 'CAN_ACCESS_AGENTSPOT',
        CAN_MANAGE_INPUT_TABLES: 'CAN_MANAGE_INPUT_TABLES',
        CAN_EDIT_INPUT_TABLES: 'CAN_EDIT_INPUT_TABLES',
        CAN_CREATE_LIVEBOARD: 'CAN_CREATE_LIVEBOARD',
        CAN_CREATE_ANSWERS: 'CAN_CREATE_ANSWERS',
        CAN_ANALYZE_DATA: 'CAN_ANALYZE_DATA',
        CAN_ADMINISTER_SCHEDULES: 'CAN_ADMINISTER_SCHEDULES',
    },
    dataSourceConfiguration: {
        PRE_SCRIPT_STATUS: 'PreScriptStatus',
        POST_SCRIPT_STATUS: 'PostScriptStatus',
    },
    relationshipMetadataType: {
        SYSTEM_RELATIONSHIP: 'PK_FK',
        GENERIC: 'GENERIC',
        USER_DEFINED: 'USER_DEFINED',
    },
    relationshipCount: {
        COUNT: 'relationshipCount',
        RELATIONSHIPS_KEY: 'relationships',
        RELATIONSHIPS_WITHIN_KEY: 'relationshipsWithin',
        connection: {
            RELATIONSHIPS_KEY: 'relationships',
            RELATIONSHIPS_WITHIN_KEY: 'relationshipsWithin',
        },
    },
    autoWorksheet: {
        ROW_COUNT: 'ROW_COUNT',
        NAME: 'NAME',
        listColumnsIds: {
            SELECTION_ID: 'selectionColumn',
            NAME: 'name',
            ROW_COUNT: 'rowCount',
        },
    },
    userSchemaErrorTypes: {
        validRows: 'VALID_ROWS',
        invalidRows: 'INVALID_ROWS',
        rowError: 'ROW_ERROR',
        invalidFile: 'INVALID_FILE',
        key: 'KEY',
        relationship: 'RELATIONSHIP',
        column: 'COLUMN',
    },
    category: {
        ALL: 'ALL',
        MY: 'MY',
        REQUESTED: 'REQUESTED',
        FAVORITE: 'FAVORITE',
    },
    tableTypes: {
        Imported: 'FalconUserDataSchema',
        Tables: 'falcon_default_schema',
    },
    permission: {
        NO_ACCESS: 'NO_ACCESS',
        READ_ONLY: 'READ_ONLY',
        MODIFY: 'MODIFY',
        VARIES: 'VARIES',
    },
    clientExpressionColumnType: {
        NONE: 'NONE',
        LOGICAL_COLUMN: 'LOGICAL_COLUMN',
        VIZ_COLUMN: 'VIZ_COLUMN',
    },
    metrics: {
        actionType: {
            NONE: 'NONE',
        },
    },
    vizType: {
        CHART: 'CHART',
        FILTER: 'FILTER',
        GENERIC_VIZ: 'GENERIC_VIZ',
        PINBOARD_VIZ: 'PINBOARD_VIZ',
        TABLE: 'TABLE',
        HEADLINE: 'HEADLINE',
        R_ANALYSIS: 'R_ANALYSIS',
    },
    genericVizSubtype: {
        SEARCH_SUMMARY_VIZ: 'SEARCH_SUMMARY_VIZ',
        SEARCH_DETAIL_TABLE_VIZ: 'SEARCH_DETAIL_TABLE_VIZ',
        SEARCH_DETAIL_NODE_VIZ: 'SEARCH_DETAIL_NODE_VIZ',
        DATABASE_SUMMARY_VIZ: 'DATABASE_SUMMARY_VIZ',
        DATABASE_DETAIL_VIZ: 'DATABASE_DETAIL_VIZ',
        CLUSTER_SUMMARY_VIZ: 'CLUSTER_SUMMARY_VIZ',
        CLUSTER_DETAIL_INFO_VIZ: 'CLUSTER_DETAIL_INFO_VIZ',
        CLUSTER_DETAIL_LOG_VIZ: 'CLUSTER_DETAIL_LOG_VIZ',
        CLUSTER_DETAIL_SNAPSHOT_VIZ: 'CLUSTER_DETAIL_SNAPSHOT_VIZ',
        ALERT_SUMMARY_VIZ: 'ALERT_SUMMARY_VIZ',
        EVENT_SUMMARY_VIZ: 'EVENT_SUMMARY_VIZ',
        ALERT_DETAIL_ALERTS_VIZ: 'ALERT_DETAIL_ALERTS_VIZ',
        ALERT_DETAIL_EVENTS_VIZ: 'ALERT_DETAIL_EVENTS_VIZ',
        ALERT_DETAIL_NOTIFICATIONS_VIZ: 'ALERT_DETAIL_NOTIFICATIONS_VIZ',
    },
    productType: {
        ENTERPRISE: 'ENTERPRISE',
        TRIAL_TEAM: 'TRIAL_TEAM',
        PRO: 'PRO',
        FREE_TRIAL: 'FREE-TRIAL',
        TEAM: 'TEAM',
        TSE: 'TSE',
        TSA: 'TSA',
        TSA_ESSENTIALS: 'TSA_ESSENTIALS',
        TSE_ESSENTIALS: 'TSE_ESSENTIALS',
        TSA_PRO: 'TSA_PRO',
        TSE_PRO: 'TSE_PRO',
        TSA_ENTERPRISE: 'TSA_ENTERPRISE',
        TSE_ENTERPRISE: 'TSE_ENTERPRISE',
    },
    adminUI: {
        CLUSTER_NAME: 'cluster_name',
        RELEASE: 'release_name',
        NODE_INFO: 'node_info',
        LAST_SNAPSHOT_TIME: 'finish_timestamp_seconds',
        INFO_ALERT: 'INFO',
        WARNING_ALERT: 'WARNING',
        CRITICAL_ALERT: 'CRITICAL',
    },
    lightWeightDataCache: {
        LOAD_STATUS_SUCCESS: 'success',
        LOAD_STATUS_FAILED: 'failed',
    },
    currencyTypes: {
        FROM_USER_LOCALE: 'FROM_USER_LOCALE',
        FROM_COLUMN: 'FROM_COLUMN',
        FROM_ISO_CODE: 'FROM_ISO_CODE',
    },
    SuggestValuesOnSearch: {
        INDEX_TYPE: 'indexType',
        DONT_INDEX: 'DONT_INDEX',
    },
    geoConfigType: {
        LATITUDE: 'LATITUDE',
        LONGITUDE: 'LONGITUDE',
        ZIP_CODE: 'ZIP_CODE',
        ADMIN_DIV_0: 'ADMIN_DIV_0',
        ADMIN_DIV_1: 'ADMIN_DIV_1',
        ADMIN_DIV_2: 'ADMIN_DIV_2',
        CUSTOM_REGION: 'CUSTOM_REGION',
        AUTO: 'AUTO',
        POINT: 'POINT',
    },
    queryInfo: {
        DATA: 'data',
    },
    scheduledJob: {
        PINBOARD_ID: 'pinboard_id',
    },
    SCHEDULER_CONFIG: 'scheduledReportingConfig',
    EMAIL_DOMAINS_WHITELIST: 'whitelistedDomains',
    SHOW_WHITELISTED_DOMAINS: 'showWhitelistedDomains',
    vizColumn: {
        DATA_RECENCY: 'baseDataRecency',
    },
    filter: {
        FILTER_CONTENT: 'filterContent',
        ROWS: 'rows',
        filterValue: {
            KEY: 'key',
            SELECTED: 'selected',
            KEYNULL: 'keyNull',
        },
        COLUMN: 'column',
        SINGLE_OPERATOR_KEY: 'oper',
        MULTIPLE_OPERATORS_KEY: 'multiOperatorValues',
        MULTIPLE_OPERATOR: {
            OPERATOR: 'operator',
            VALUES: 'filterValues',
        },
        ROW_INDEX: 'rowIndex',
        NEGATION: 'negation',
        IS_EDITABLE: 'isEditable',
        LIST_FILTER_KEYS: {
            AUTHOR_FILTER: 'category',
        },
        SAVED_FILTERS: {
            AUTHOR_FILTER: 'savedAuthorFilter',
        },
    },
    visualizationModel: {
        VIZ_JSON: 'vizJson',
    },
    relatedLink: {
        DESTINATION_VIZ_ID: 'dstVizId',
        RELATED_LINKS: 'relatedLinks',
    },
    header: {
        ID: 'id',
        NAME: 'name',
        DESCRIPTION: 'description',
        OWNER: 'owner',
        AUTHOR: 'author',
        IS_HIDDEN: 'isHidden',
        IS_DELETED: 'isDeleted',
        IS_FAVORITE: 'isFavorite',
        IS_EXTERNAL_KEY: 'isExternal',
        MODIFIED: 'modified',
        STATUS: {
            RESOLVED: 'RESOLVED',
            UNRESOLVED: 'UNRESOLVED',
        },
    },
    storable: {
        CONTENT: 'content',
    },
    a3: {
        SELECTION_INCLUDE: 'include',
        SELECTION_EXCLUDE: 'exclude',
    },
    a3Algorithms: {
        STDEV_MEAN: 'STDEV_MEAN',
        MAD_MEDIAN: 'MAD_MEDIAN',
        ANOMALY_EXPLANATION: 'ANOMALY_EXPLANATION',
        SHESD: 'SHESD',
        LINEAR_REGRESSION: 'LINEAR_REGRESSION',
        CUSTOM_SCRIPT: 'CUSTOM_SCRIPT',
        TREND_ANALYSIS: 'TREND_ANALYSIS',
        CROSS_CORRELATION: 'CROSS_CORRELATION',
        K_MEANS_CLUSTERING: 'K_MEANS_CLUSTERING',
    },
    chartClientStateKeys: {
        SYSTEM_SERIES_COLORS: 'systemSeriesColors',
        SERIES_COLORS: 'seriesColors',
        SYSTEM_MULTI_COLOR_SERIES_COLORS: 'systemMultiColorSeriesColors',
        MULTI_COLOR_SERIES_COLORS: 'multiColorSeriesColors',
    },
    paginationTabsState: {
        EMPTY: 'empty',
        SELECTED: 'selected',
    },
    optimizely: {
        OPTIMIZELY_DATA_FILE_FETCH_INTERVAL: 'optimizelyDataFileFetchInterval',
    },
    systemR: {
        R_ANALYSIS_OUTPUT: 'ranalysisOutput',
        PNG_OUTPUT: 'PNG',
        CSV_OUTPUT: 'CSV',
        SAGE_OUTPUT_COLUMN_ID: 'sage_output_column_id',
        VARIABLE_NAME: 'variable_name',
        COLUMN_NAME: 'column_name',
    },
    timeBuckets: {
        ABS_WEEK_AS_EPOCH: 'ABS_WEEK_AS_EPOCH',
        WEEK_IN_YEAR_AS_EPOCH: 'WEEK_IN_YEAR_AS_EPOCH',
        ABS_MONTH_AS_EPOCH: 'ABS_MONTH_AS_EPOCH',
        ABS_QUARTER_AS_EPOCH: 'ABS_QUARTER_AS_EPOCH',
        ABS_YEAR_AS_EPOCH: 'ABS_YEAR_AS_EPOCH',
        ABS_DAY_AS_EPOCH: 'ABS_DAY_AS_EPOCH',
        ABS_HOUR_AS_EPOCH: 'ABS_HOUR_AS_EPOCH',
        HOUR_OF_DAY: 'HOUR_OF_DAY',
        DAY_OF_WEEK: 'DAY_OF_WEEK',
        DAY_OF_MONTH: 'DAY_OF_MONTH',
        DAY_OF_QUARTER: 'DAY_OF_QUARTER',
        DAY_OF_YEAR: 'DAY_OF_YEAR',
        WEEK_OF_MONTH: 'WEEK_OF_MONTH',
        WEEK_OF_QUARTER: 'WEEK_OF_QUARTER',
        WEEK_OF_YEAR: 'WEEK_OF_YEAR_ISO',
        MONTH_OF_QUARTER: 'MONTH_OF_QUARTER',
        MONTH_OF_YEAR: 'MONTH_OF_YEAR',
        QUARTER_OF_YEAR: 'QUARTER_OF_YEAR',
    },
    embedData: {
        NAME: 'name',
        COLUMN_NAMES: 'columnNames',
        SAMPLING_RATIO: 'samplingRatio',
        TOTAL_ROW_COUNT: 'totalRowCount',
        ROW_COUNT: 'rowCount',
        DATA: 'data',
        PAGE_SIZE: 'pageSize',
        OFFSET: 'offset',
    },
    userAccountSource: {
        INTERNAL: 'internal',
        SNOWFLAKE_PARTNER_CONNECT: 'snowflake_partner_connect',
        FREE_TRIAL: 'free_trial',
    },
    userPersona: {
        analyst: 'ANALYST',
        business_user: 'BUSINESS_USER',
        business_persona: 'BUSINESS_PERSONA',
        analyst_persona: 'ANALYST_PERSONA',
        developer_persona: 'DEVELOPER_PERSONA',
    },
    userType: {
        LOCAL_USER: 'LOCAL_USER',
        OIDC_USER: 'OIDC_USER',
    },
    groupType: {
        LOCAL_GROUP: 'LOCAL_GROUP',
    },
    version: {
        RELEASE: 'releaseVersion',
    },
    INVITE_MODAL_TYPE: 'inviteModalType',
    SCHEDHULE_MAINTAINANCE: 'maintenanceSchedule',
    AAQ_ENABLED: 'aaqEnabled',
    edoc: {
        WORKSHEET: 'worksheet',
        TABLE_PATHS: 'table_paths',
        WORKSHEET_COLUMNS: 'worksheet_columns',
        COLUMNS: 'columns',
        MODEL: 'model',
        MODEL_TABLES: 'model_tables',
    },
    AUTOGEN_CONFIG: 'autoGenConfig',
    ALL_TABLES_CONNECTION_ID: 'allTablesConnectionId',
    WORKSHEETGEN_CONFIG: 'worksheetGen',
    WORKSHEETGEN_ENABLED: 'enabled',
    ANSWER_GEN: 'answerGen',
    ANSWERGEN_ENABLED: 'enabled',
    INTERCOM_APP_ID: 'intercomAppId',
    INTERCOM_USER_HASH: 'intercomUserHash',
    MAX_CSV_FILE_UPLOAD_COUNT: 'maxCSVFileUploadCount',
    CSV_TABLES: 'csvTables',
    DISALLOW_PRIVILAGE_ADDITION: 'disallowPrivilegeAddition',
    ADMIN_PRIVILEGE_SEGREGATION: 'adminPrivilegeSegregation',
    FREE_TRIAL_ACTIVATION_SCREEN_ENABLED: 'isFreeTrialActivationEnabled',
    SHOW_LOGIN_WITH_USER_EMAIL: 'showLoginWithUserEmail',
    ENABLE_PINBOARD_FOLLOW: 'enablePinboardFollow',
    DISABLE_MOBILE_DEEP_LINK: 'disableMobileDeeplink',
    IS_ANSWER_UNDO_STACK_ENABLED: 'isAnswerUndoStackEnabled',
    TEAM_EDITION_CONFIG: 'teamEdition',
    TEAM_EDITION_ENABLED: 'enabled',
    DATA_WORKSPACE_CONFIG: 'dataWorkspace',
    PARTNER_CONNECT_CONFIG: 'partnerConnectConfig',
    PARTNER_SERVICE_CONFIG: 'partnerServiceConfig',
    MAX_PRINCIPAL_OBJECTS_BATCH_SIZE: 'maxPrincipalObjectsBatchSize',
    ENABLE_PARTITIONED_COOKIE: 'enablePartitionedCookies',
    ISSUERS: 'issuers',
    SENTRY_ANONYMIZED_DSN: 'sentryAnonymizedDSN',
    SENTRY_FULL_DSN: 'sentryFullDSN',
    REPLAY_LINK_BASE_URL: 'replayLinkBaseUrl',
    LEGAL_DISCLAIMER_TEXT: 'legalDisclaimerText',
    REMOVE_ATTACHMENT_FROM_SCHEDULED_EMAILS: 'removeAttachmentFromScheduledEmails',
    ENABLE_ROLES: 'rolesEnabled',
    RBAC_FOR_EMBRACE: 'enableRBACForEmbrace',
    SEARCH_CACHE_ENABLED: 'enableSearchCache',
    SPOT_IQ_V2_EXPERIENCE: 'spotIQV2Experience',
    IS_SPOT_IQ_V2_ON_BY_DEFAULT: 'isSpotIQV2OnByDefault',
    API_PLAYGROUND_CONFIG: 'apiPlaygroundConfig',
    API_PLAYGROUND_ENABLED: 'enabled',
    EMBED_SETTINGS_NOT_FOUND: 'embedSettingsNotFound',
    SEARCH_DATA_IN_NAV: 'searchDataInNav',
    EUREKA_SEARCH_BAR_IN_NAV: 'eurekaSearchBarInNav',
    EUREKA_SEARCH_BAR_IN_NAV_ENABLED: 'eurekaSearchBarInNavEnabled',
    AI_ANSWER_GENERATION_ENABLED: 'aiAnswerGenerationEnabled',
    IS_NL_INSTRUCTIONS_IN_SPOTTER_ENABLED: 'isNLInstructionsInSpotterEnabled',
    SHOW_SPOTTER_PAST_CONVERSATIONS: 'showSpotterPastConversations',
    ENABLE_SPOTTER_CONVERSATION_SEARCH: 'enableSpotterConversationSearch',
    ENABLE_LLM_GATEWAY_V2: 'enableLLMGatewayV2',
    ENABLE_BYO_LLM: 'enableBYOLLM',
    SERP_VERSION: 'serpVersion',
    AI_ANSWER_GENERATION_DISABLED: 'aiAnswerGenerationDisabled',
    NLS_FEEDBACK_CRUD_UI_ENABLED: 'nlsFeedbackCRUDUiEnabled',
    ENABLE_SAGE_COACH_MFE: 'enableSageCoachMFE',
    NLS_FEEDBACK_LEARNABILITY_UI_ENABLED: 'nlsFeedbackLearnabilityUiEnabled',
    SPOTTER_EXPERIENCE: 'isSpotterExperienceEnabled',
    IS_STARTER_PROMPTS_ENABLED: 'isStarterPromptsEnabled',
    ENABLE_SPOTTER_DATA_SOURCE_DISCOVERY: 'enableSpotterDataSourceDiscovery',
    IS_SPOT_ENABLED: 'isSpotEnabled',
    TRY_EVERYWHERE_URL: 'tryEverywhereURL',
    ENABLE_SAGE_WARNING_MESSAGES: 'enableSageWarningMessages',
    CAPTAIN_ENABLED: 'captainEnabled',
    ORGS_CONFIGURATION: 'orgsConfiguration',
    ORG_UI_ENABLED: 'enabled',
    ACCESSIBLE_ORGS: 'accessibleOrgs',
    CURRENT_ORG_ID: 'currentOrgId',
    CURRENT_ORG_NAME: 'currentOrgName',
    DEFAULT_ORG_NAME: 'Primary',
    ORGS_CLEANUP_ENABLED: 'orgsCleanUpEnabled',
    SECURITY_SETTINGS_PER_ORG_ENABLED: 'securitySettingsPerOrgFeatureEnabled',
    ORGS_HIDDEN: 'orgsHidden',
    TOKEN_AUTH_PER_ORG_ENABLED: 'tokenAuthPerOrgEnabled',
    HIDE_ORG_SWITCHER_UI: 'hideOrgSwitcherUI',
    EXPERIMENTATION: 'experimentation',
    MIXPANEL_CONFIG: 'mixpanelConfig',
    SUBSCRIPTION_STATUS: 'subscriptionStatus',
    ENABLE_NOTIFICATION_ON_SHARE: 'enableNotificationOnShare',
    TSE_HIDE_DEVELOP_FOR_ORGS: 'tseHideDevelopForOrgs',
    SUPER_USER_GUID: 'superUserGuid',
    SYSTEM_USER_GUID: 'systemUserGuid',
    USER_GUID: 'userGUID',
    ADMIN_GROUP_GUID: 'adminGroupGuid',
    SYSTEM_GROUP_GUID: 'systemGroupGuid',
    UPDATE_DISPLAY_NAME_ENABLED: 'updateDisplayNameEnabled',
    HTML_RENDERING_DISABLED: 'htmlRenderingDisabled',
    TSADMIN_USER_GUID: 'tsadminUserGuid',
    HIDDEN_OBJECT_GUID: 'hiddenObjectGuid',
    ALL_ORG_USER_GROUP_ID: 'allOrgUserGroupId',
    ALL_ORGS_GROUP_GUID: 'allOrgsGroupGUID',
    USER_PROPERTIES: 'userProperties',
    OKTA_USER_ID: 'oktaUserId',
    SPOTAPPS_VALIDATOR: 'spotAppsValidator',
    IS_SHARE_V2_ENABLED: 'isShareV2Enabled',
    IS_DISCOUNT_FOR_TRIAL_USER_ENABLED: 'enableDiscountForTrialUser',
    IS_ORGS_ON_FT_ENABLED: 'enableOrgsOnFT',
    NEW_HOMEPAGE_EXPERIENCE: 'newNavigationHomepageExperience',
    IS_NEW_HOMEPAGE_EXPERIENCE_ON_BY_DEFAULT: 'isNewNavigationHomepageExperienceOnByDefault',
    IS_LIBRARY_FILTERING_IMPROVEMENTS_ENABLED: 'isLibraryFilteringImprovementsEnabled',
    LEARNING_MODULE_VIDEOS_LIST: 'learningModuleVideosList',
    IS_INVITE_ENABLED_INSHARE_V2: 'isInviteEnabledInShareV2',
    SKIP_LIVEBOARDS_ID: 'skipLiveboardIds',
    SKIP_WORKSHEETS_IDS: 'skipWorksheetIds',
    MAX_NUM_TIMES_DISPLAY_NAME_DIALOG_SHOWN: 'maxNumTimesDisplayNameDialogShown',
    LOGIN_ENABLED_FOR_EXPIRED_USER: 'loginEnabledForExpiredUser',
    ENABLE_SHARE_IN_INVITE: 'enableShareInInvite',
    MDU_BANNER_NOTIFICATION: 'notificationBanner',
    USER_STATE: 'state',
    CUSTOM_REGION: {
        CONFIG: 'customRegionConfig',
        ENABLED: 'enabled',
        MAX_FILE_LIMIT: 'maxFileLimit',
        MAX_FILE_SIZE: 'maxFileSize',
    },
    IS_SORT_BY_LAST_MODIFIED_ENABLED: 'isSortByLastModifiedEnabled',
    ENABLE_CUSTOM_CHARTS: 'enableCustomCharts',
    HANDLE_MISSING_VALUES: 'handleMissingValues',
    DEFAULT_ZOOMED_WIDTH_FOR_EXPORT: 1920,
    NOTE_TILES: 'isNoteTilesEnabled',
    IS_EMBED_IN_NOTE_TILES: 'isEmbedInNoteTilesEnabled',
    IS_COMS_FOR_LIVEBOARD_SCHEDULES_ENABLED: 'comsForLiveboardSchedulesEnabled',
    IS_LIVEBOARD_PNG_EXPORT_V2_ENABLED: 'isLiveboardPNGExportV2Enabled',
    IS_PNG_IN_SCHEDULED_EMAILS_ENABLED: 'isPNGInScheduledEmailsEnabled',
    EMBED_PNG_SCALE: 'embedPngScale',
    IS_ANSWER_EXPORT_V2_ENABLED: 'isAnswerExportV2Enabled',
    IS_WYSIWYG_LIVEBOARD_PDF_ENABLED: 'isWYSIWYGLiveboardPDFEnabled',
    IS_GRANULAR_XLSX_CSV_SCHEDULES_ENABLED: 'isGranularXLSXCSVSchedulesEnabled',
    IS_EVERY_N_MINUTES_FREQUENCY_DISABLED: 'isEveryNMinutesFrequencyDisabled',
    IS_LIVEBOARD_SCHEDULES_UTILITY_DISABLED: 'isLiveboardSchedulesUtilityDisabled',
    IS_COMBINED_XLSX_REPORT_ENABLED: 'isCombinedXLSXReportEnabled',
    IS_SEND_NOW_LIVEBOARD_SCHEDULING_ENABLED: 'isSendNowLiveboardSchedulingEnabled',
    IS_LINK_PARAMETERS_ENABLED: 'isLinkParametersEnabled',
    MANDATORY_FILTER: 'isMandatoryFilterEnabled',
    COMPACT_LAYOUT: 'isCompactLayoutEnabled',
    MOBILE_RESPONSIVENESS_FOR_LIVEBOARD: 'isMobileResponsiveLiveboardEnabled',
    CROSS_FILTERS: 'isCrossFiltersEnabled',
    HIDDEN_COLUMN_WS_ACCESS: 'isHiddenColWSAccessible',
    DATE_PICKER: 'isDatePickerEnabled',
    DATE_FILTER_CHIP_MATCHING: 'isDateFilterChipMatchingSearchToken',
    THIS_PERIOD_IN_DATE_FILTERS: 'isThisPeriodInDateFiltersEnabled',
    SCOPED_LIVEBOARD_FILTERING: 'isScopedLiveboardFilteringEnabled',
    HIDE_PREVIEW_FOR_ROLLING_FILTERS_WITH_CC: 'hidePreviewForRollingFiltersWithCC',
    TABLE_WIDTH_SCALING: 'isTableWidthScalingEnabled',
    CONTEXT_MENU_ON_LEFT_CLICK: 'isContextMenuEnabledOnLeftClick',
    TOOLTIP_CUSTOMIZATION: 'isTooltipCustomizationEnabled',
    ENHANCED_CF: 'isEnhancedCfEnabled',
    PREFETCH_HEADLINE_DATA: 'isPrefetchHeadlineDataEnabled',
    GRADIENT_COLORING: 'isGradientColoringEnabled',
    CHART_SETTINGS_V2: 'isChartSettingsV2Enabled',
    PROGRESSIVE_ANSWER_ENABLED: 'progressiveAnswerEnabled',
    ATTRIBUTE_NF: 'isAttributeNfEnabled',
    CHART_SKILLS: 'isChartSkillsEnabled',
    SKIP_CLIENT_STATE_SCHEMA_CHECK: 'skipClientStateSchemaCheck',
    STANDARD_REGION: {
        CONFIG: 'standardRegionConfig',
        ENABLED: 'enabled',
    },
    HIGHCHART_CUSTOMISATION: 'isHighchartCustomisationEnabled',
    HIDE_IRRELEVANT_FILTERS_AT_TAB_LEVEL: 'hideIrrelevantFiltersAtTabLevel',
    LIVEBOARD_STICKY_HEADER: 'isLiveboardHeaderSticky',
    LIVEBOARD_HEADER_V2: 'isLiveboardHeaderV2Enabled',
    LIVEBOARD_STYLING: 'isLiveboardStylingEnabled',
    LIVEBOARD_MASTERPIECES: 'isLiveboardMasterpiecesEnabled',
    ANSWER_EDIT_IN_LIVEBOARD_EDIT_MODE: 'isAnswerEditInLiveboardEditModeEnabled',
    INSIGHT_TILE: 'isInsightTileEnabled',
    INSIGHT_TILE_BACKGROUND: 'isInsightTileBackgroundEnabled',
    IS_SPOTTER_X_ENABLED: 'isSpotterXEnabled',
    IS_SPOTTER_AVAILABLE: 'isSpotterAvailable',
    SHOW_SPOTTER_X_OPTION_ON_ADMIN_PANEL: 'showSpotterXOptionOnAdminPanel',
    SHOW_LINKS_ON_SPOTTER_ADMIN_PANEL: 'showLinksOnSpotterAdminPanel',
    PDF_OPTIONS: {
        ARE_PDF_COVER_FILTER_PAGE_CHECKBOXES_ENABLED: 'arePdfCoverFilterPageCheckboxesEnabled',
        ARE_PDF_COVER_FILTER_PAGE_DEFAULTS_CHECKED: 'arePdfCoverFilterPageDefaultsChecked',
    },
    ALLOW_CREATING_WORKSHEET_TO_UPLOADED_TABLE_JOINS: 'allowCreatingWSToUploadedTableJoins',
    METADATA_UPDATE_SYNONYMS_PARAM_KEYS: {
        IDS: 'ids',
        MARK_EXISTING_USER_EDITED: 'markExistingUserEdited',
    },
    METADATA_UPDATE_SYNONYMS_SUCCESS_STATUS: 204,
    METADATA_DELETE_AUTOGENERATED_SYNONYMS_PARAM_KEYS: {
        IDS: 'ids',
    },
    METADATA_DELETE_AUTOGENERATED_SYNONYMS_SUCCESS_STATUS: 204,
    FILTER_SINGLE_VALUE_SELECTION: 'isFilterSVSEnabled',
    FILTER_RENAMING: 'isFilterRenamingEnabled',
    REACT_SHELL_EXPERIENCE: 'reactShellExperience',
    CUSTOM_SORTING: 'isCustomSortingEnabled',
    IS_CUSTOM_LABEL_PROCESSING_DISABLED: 'isCustomLabelProcessingDisabled',
    PERSONALISED_VIEWS: 'isPersonalisedViewsEnabled',
    WORKSHEET_V1_AND_V2_ENABLED: 'createV1AndV2Worksheet',
    WORKSHEET_V2_DEFAULT: 'createV2WorksheetAsDefault',
    CONVERT_TO_MODEL: 'convertToModel',
    DISABLE_EDIT_WORKSHEET_FLOW: 'disableEditWorksheet',
    SYNCINDEX_SETTING_WITH_SOURCE: 'syncIndexSettingWithSource',
    ENABLE_V2_KNOWLEDGE_CARD: 'enableV2KnowledgeCard',
    ENABLE_SLACK_DISCONNECTED_BANNER: 'enableSlackDisconnectedBanner',
    DROP_QUESTION_ON_WORKSHEET_PAGE: 'dropQuestionOnWorksheetPage',
    TML_TABLE_REMAPPING_ENABLED: 'tmlTableRemappingEnabled',
    TML_UTILITY_V2_ENABLED: 'isTmlUtilityV2Enabled',
    METRICS_FLOATER_ENABLED: 'webpageMetrics',
    ENABLE_CACHE_CLEANUP: 'enableCacheCleanup',
    CONNECTION_TML_ENABLED: 'connectionTMLSupportEnabled',
    COLLECTION_TML_IMPORT_EXPORT_ENABLED: 'collectionTmlImportExportEnabled',
    WORKSHEET_JOIN_RECOMMENDATION_ENABLE: 'enableJoinRecommendations',
    JOIN_ALLOWED_WITH_COMPATIBLE_DATA_TYPE: 'joinAllowedWithCompatibleDataType',
    SUPPORT_OBJECT_DELETION_WITH_DEPENDENTS: 'supportDeletionWithDependents',
    SHOW_GENERIC_JOIN_CREATION_MODAL: 'showGenericJoinCreationModal',
    ENABLE_GLOBAL_JOIN_DIREACTION_REVERSAL: 'enableGlobalJoinDirectionReversal',
    OBJECT_SECURITY_CONFIG: 'objectSecurityConfig',
    OBJECT_SECURITY_CONFIG_OPTIONS: {
        COLUMN_SECURITY_RULE_ENABLED: 'columnSecurityRuleEnabled',
        COLUMN_SECURITY_ABAC_ENABLED: 'csrABACEnabled',
    },
    LIVEBOARD_QUERY_STATUS: 'liveboardVizQueryStatusConfig',
    LIVEBOARD_VIZ_DATA_CACHE_ENABLED: 'liveboardVizDataCacheEnabled',
    MUZE_CHART_IDB_CACHE_ENABLED: 'muzeChartIdbCacheEnabled',
    LIVEBOARD_VIZ_DATA_CACHE_ENABLED_FOR_ALL: 'liveboardVizDataCacheEnabledForAll',
    LIVEBOARD_VIZ_DATA_CACHE_ORG_ENABLED: 'liveboardVizDataCacheOrgEnabled',
    LIVEBOARD_VIZ_DATA_CACHE_ALL_LIVEBOARDS_PER_ORG: 'liveboardVizDataCacheAllLiveboardsPerOrg',
    LIVEBOARD_VIZ_DATA_CACHE_LIVEBOARD_IDS_PER_ORG: 'liveboardVizDataCacheLiveboardIdsPerOrg',
    VIZ_RENDER_SCROLL_DEBOUNCE_MS: 'vizRenderScrollDebounceMs',
    LOAD_CONTEXT_BOOK_API_DEBOUNCE_MS: 'loadContextBookAPIDebounceMs',
    LIVEBOARD_MIXED_CACHE_THRESHOLD_MINUTES: 'liveboardMixedCacheThresholdMinutes',
    ENABLE_VIEWPORT_AWARE_VIZ_RENDER: 'enableViewportAwareVizRender',
    ENABLE_KPI_RENDER_OPTIMIZATION: 'enableKpiRenderOptimization',
    ENABLE_LAYOUT_OPTIMIZATIONS: 'enableLayoutOptimizations',
    CSV_UPLOAD_MODE: 'csvUploadMode',
    DATA_MANAGER_SERVICE_CONFIG: 'dataManagerServiceConfig',
    DATA_MANAGER_SERVICE_CONFIG_OPTIONS: {
        INCLUDE_MILLI_SECONDS: 'includeMilliSeconds',
    },
    AI_MODEL_TYPE: 'aiModelType',
    IS_CUSTOMER_LLM_ACCOUNT: 'isCustomerLLMAccount',
    DEMO_HOST_CLUSTER_URL: 'demoHostClusterURL',
    DEMO_LIVEBOARD_GUID: 'demoLiveboardGuid',
    MERGE_PIVOT_EXPORTED_ROWS_AND_COLUMNS: 'mergePivotExportedRowsAndColumns',
    RENAMING_COLUMNS_ENABLED: 'isRenamingColumnsEnabled',
    HIDDEN_TABLE_COLUMNS: 'isHiddenTableColumnsEnabled',
    STRICT_PRIVILEGE_MANAGEMENT_ENABLED: 'strictPrivilegeManagementEnabled',
    GIT_INTEGRATION: 'gitIntegration',
    GIT_INTEGRATION_UI: 'enableVcsUI',
    USERS_GROUPS_V2_EXPERIENCE: 'usersGroupsV2Experience',
    IS_USERS_GROUPS_V2_ON_BY_DEFAULT: 'isUsersGroupsV2OnByDefault',
    AUTH_V2_EXPERIENCE: 'authV2Experience',
    IS_AUTH_V2_ON_BY_DEFAULT: 'isAuthV2OnByDefault',
    ORG_PER_URL_ENABLED: 'orgPerUrlEnabled',
    LIVEBOARD_SSR_CACHE_ENABLED: 'liveboardSSRCacheEnabled',
    IS_VERSION_HISTORY_ENABLED: 'isVersionHistoryEnabled',
    CUSTOM_NUMBER_FORMAT_PATTERN_FOR_GEO_CHART: 'customNumberFormatPatternForGeoChart',
    LIVEBOARD_HIGHLIGHTS: 'isLiveboardHighlightsEnabled',
    LIVEBOARD_HIGHLIGHTS_TOAST: 'isLiveboardHighlightsToastEnabled',
    LIVEBOARD_HIGHLIGHTS_QUERY_TIMEOUT: 'liveboardHighlightsQueryTimeout',
    LIVEBOARD_BREAKPOINTS: 'isLiveboardNewBreakPointsEnabled',
    LIVEBOARD_SCHEDULE_HOME_ENABLED: 'isScheduleOnHomeEnabled',
    IS_SOFTWARE_CLUSTER: 'isSoftware',
    IS_MULTI_TENANT_CALENDAR_CONFIG_ENABLED: 'isMultiTenantCalendarConfigEnabled',
    MAX_NO_OF_FILTER_VALUES_IN_MODAL: 'maxNumFilterValuesInModal',
    PAYLOAD_RUNTIME_FILTER_LIMIT: 'payloadRuntimeFilterLimit',
    CONNECTION_CONFIGURATION_ENABLED: 'connectionConfigurationEnabled',
    CONNECTION_CONFIGURATION_ENABLED_CDW: 'connectionConfigurationEnabledCDWs',
    CONNECTORS_WITH_OPTIONAL_DATABASE_ENABLED: 'connectorsWithOptionalDatabaseEnabled',
    SHOW_SERVICE_ACCOUNT_ONLY: 'shouldShowServiceAccountOnly',
    SHOW_DELETE_CAPTAIN_WORKSPACE: 'showDeleteCaptainWorkspace',
    IS_DYNAMIC_COLUMN_WIDTH_FOR_PIVOT_ENABLED: 'isDynamicColumnWidthForPivotEnabled',
    ALLOW_PV_SHARE_ENABLED: 'isAllowPVShareEnabled',
    DIGEST_FREQUENCY: 'digestFrequency',
    LOGOUT_WITH_REDIRECT: 'shouldLogoutWithRedirect',
    SHOULD_SHOW_FRAGMENT_CONFIRMATION_MODAL: 'shouldShowFragmentConfirmationModal',
    SHOULD_SHOW_OPTIMIZE_SAGE_BTN: 'shouldShowOptimizeSageBtn',
    MEASURE_NAMES_ENABLED: 'measureNamesEnabled',
    ENABLE_REACT_WORKSHEET: 'enableReactWorksheet',
    ENABLE_REACT_METADATA_DETAILS: 'enableMetadataDetailsInReact',
    ENABLE_REACT_SCHEMA_DETAIL_JOINS: 'schemaDetailsJoinInReact',
    ENABLE_FEEDBACK_MIGRATION: 'isFeedbackMigrationEnabled',
    ENABLE_COLUMN_ALIAS: 'enableColumnAlias',
    ENABLE_COLUMN_ALIAS_UDF: 'enableColumnAliasUdf',
    ENABLE_V2_MODEL_SHARE: 'enableV2ModelShare',
    SYNC_WITH_SOURCE: 'syncWithSource',
    ENABLE_NON_EQUI_JOIN_IN_UI: 'enableNonEquiJoinInUI',
    ENABLE_COLUMN_DEPENDENCY_DELETE: 'enableColumnDependencyDeletion',
    ENABLE_AI_MODELING: 'enableAiModeling',
    IS_SPOTTER_MODEL_SECTION_HIDDEN_IN_ADMIN_PORTAL: 'isSpotterModelSectionHiddenInAdminPortal',
    ENABLE_REACT_SCHEMA_VIEWER: 'enableReactSchemaViewer',
    ENABLE_CHUNKED_METADATA_FETCH: 'enableChunkedMetadataFetch',
    ENABLE_COLUMNS_CSV_IMPORT_EXPORT: 'enableColumnsCsvImportExport',
    DISABLE_V1_ROUTES: 'v1Disabled',
    ACCESSIBILITY_WITH_FORMATTING: 'isAccessibilityWithFormattingEnabled',
    PREFETCH_CONTEXTBOOK_ENABLED: 'isContextBookPrefetchEnabled',
    GRADIENT_BUFFER_ENABLED: 'gradientBufferEnabled',
    INTERNAL_AUTHWITH_OKTA: 'allowInternalAuthDisableForOkta',
    PER_ORG_SUBDOMAIN_ENABLED: 'enablePerOrgSubDomain',
    IDP_CONFIG_PER_ORG_ENABLED: 'enableIdpConfigPerOrg',
    NEW_SCHEDULE_MODAL_ENABLED: 'isNewScheduleModalEnabled',
    REORDERED_ELLIPSIS_MENU_ENABLED: 'isReorderedEllipsisMenuEnabled',
    DEFER_LAYOUT_WITH_RAF: 'deferLayoutWithRaf',
    ADD_ANSWER_IN_LIVEBOARD_ENABLED: 'isAddAnswerInLiveboardEnabled',
    MAX_NUM_EXPORT_ROWS: 'maxNumExportRows',
    DISPLAY_TABLE_SQL_QUERY_BY_DEFAULT: 'displayTableSqlQueryByDefault',
    PARAMETER_CHIP_REORDERING_ENABLED: 'isParameterChipReorderingEnabled',
    PDOM_DOMAIN: 'pdomDomain',
    NARROW_CURRENCY_SYMBOL_ENABLED: 'isNarrowCurrencySymbolEnabled',
    NARROW_CURRENCY_CODES: 'narrowCurrencyCodes',
    ENABLE_ADVANCED_PIVOT_TABLE: 'enableAdvancedPivotTable',
    VIZ_OVERRIDE_CONFIG_ENABLED: 'vizOverrideConfigEnabled',
    ORG_VIZ_OVERRIDE_CONFIG: 'orgVizOverrideConfig',
    ENABLE_PROFILE_TAB: 'enableProfileInTable',
    DISABLE_DATA_SAMPLE_TAB: 'disableDataSamples',
    CHANGE_ANALYSIS_SIGNIFICANT_CHANGE_COLOR: 'changeAnalysisSignificantChangeColor',
    SEND_SCHEDULE_EMAILS_TO_EXTERNAL_EMAIL: 'isLiveboardScheduleEmailRecipientEnabled',
    LIVEBOARD_TILE_GROUPING: 'isLiveboardTileGroupingEnabled',
    DISABLE_DEBUG_UI: 'disableDebugUI',
    PIE_CHART_ENHANCEMENTS: 'isPieChartEnhancementsEnabled',
    HIDE_CHART_COMPONENTS_FOR_SMALL_VIEWPORT: 'hideChartComponentsForSmallViewport',
    DEFAULT_NUMBER_FORMAT_UNIT_NONE: 'defaultNumberFormatUnitNone',
    DYNAMIC_TITLE_SUPPORTED: 'isDynamicTitleSupported',
    MUZE_STUDIO_ENABLED: 'enableMuzeStudio',
    MUZE_STUDIO_ROWS_LIMIT: 'muzeStudioRowsLimit',
    MUZE_STUDIO_AI_ENABLED: 'muzeStudioAiEnabled',
    ENABLE_MUZE_AI_CHAT: 'enableMuzeAiChat',
    ENABLE_CLIENT_SIDE_MN_MV_CALCULATION: 'enableClientSideMnMvCalculation',
    ENABLE_HOSTED_CHART_SAME_ORIGIN_SAFARI: 'enableHostedChartSameOriginSafari',
    ENABLE_ABOUT_INSTANCE_MODAL: 'enableAboutInstanceModal',
    ORG_OVERRIDE_QUERY_PARAM_KEY: 'orgId',
    OVERRIDE_NULL_WITH_VALUE: 'overrideNullWithValue',
    OVERRIDE_EMPTY_WITH_VALUE: 'overrideEmptyWithValue',
    CCA_SUGGESTED_ATTRIBUTES_LIMIT: 3,
    ENABLE_INFER_CURRENCY_FROM_BROWSER_AT_VIZ: 'enableInferCurrencyFromBrowserAtViz',
    SHOULD_STOP_REDIRECTION_ON_MANUAL_LOGOUT: 'shouldStopRedirecitonOnManualLogout',
    ENABLE_SSO_ON_ACTIVATION: 'enableSSOOnActivation',
    TRIM_CURRENCY_SPACING_ENABLED: 'trimCurrencySpacingEnabled',
    ZERO_DECIMAL_CURRENCIES: 'zeroDecimalCurrencies',
    CCA_FILTER_DISPLAY_LIMIT: 10,
    ORG_ID_QUERY_PARAM_REGEX: /(?:&|^)orgId=[^&]*/,
    MAX_LOGO_FILE_SIZE_IN_BYTES: 'maxFileSizeBytes',
    ENABLE_NOTE_TILE_TEXT_SPACING_UPDATES: 'enableNoteTileTextSpacingUpdates',
    ENABLE_TSE_ONBOARDING: 'enableTSEOnboarding',
    SMART_SORT_V2_ENABLED: 'smartSortV2Enabled',
    ENABLE_CUSTOM_BANNERS: 'enableCustomBanners',
    ENABLE_HOMEPAGE_ANNOUNCEMENT: 'enableHomepageAnnouncement',
    ENABLE_COMMAND_PALETTE: 'isCommandPaletteEnabled',
    ENABLE_AUTOMATIC_TRANSLATION: 'automaticTranslationOfObjectMetadata',
    ENABLE_MANUAL_TRANSLATION: 'manualTranslationOfObjectMetadata',
    ENABLE_MANUAL_TRANSLATION_PER_ORG: 'manualTranslationOfObjectMetadataPerOrg',
    DISABLE_LIVEBOARD_TRANSLATION: 'disableLiveboardTranslation',
    LIVEBOARD_XLSX_CSV_DOWNLOAD: 'isLiveboardXLSXCSVDownloadEnabled',
    LIVEBOARD_CENTRALIZED_FILTER_UX: 'isCentralizedLiveboardFilterUXEnabled',
    LIVEBOARD_PERMISSION_V2_ENABLED: 'isLiveboardPermissionV2Enabled',
    LIVEBOARD_INTERACTIVITY_WITH_CSR_ENABLED: 'isEnhancedLiveboardInteractivityWithCSREnabled',
    KAIOS_AGENT_ENABLED: 'enableKaiosAgent',
    CLOUD_PLATFORM: 'cloudPlatform',
    SPOTTER_VIZ_VIEW_MODE_ENABLED: 'isSpotterVizInViewModeEnabled',
    SPOTTER_VIZ_ZERO_STATE_ENABLED: 'enableSpotterVizZeroState',
    WEBHOOKS_V2_ENABLED: 'webhooksV2Enabled',
    COMS_WEBHOOK_HISTORY_RETENTION_PERIOD_IN_DAYS: 'comsWebhookHistoryRetentionPeriodInDays',
    THEME_BUILDER_AI_MODE: 'themeBuilderAiMode',
    SPOTTER_CODE_ENABLED: 'spotterCodeEnabled',
    USE_PRISM_FOR_IAM_FLOWS: 'usePrismForIAMFlows',
    SPLIT_DOWNLOAD_PRIVILEGES: 'splitDownloadPrivileges',
    LIVEBOARD_RBAC_PRIVILEGES_V2_ENABLED: 'liveboardRBACPrivilegesV2Enabled',
    OBJECT_PUBLISHING: {
        CONFIG: 'objectPublishingConfig',
        ENABLED: 'enabled',
        UI_ENABLED: 'isUIEnabled',
    },
    VARIABLES_UI_ENABLED: 'isVariablesUIEnabled',
    CUSTOM_BANNERS: 'customBanners',
    IS_MEMORY_ENABLED_IN_SPOTTER: 'isMemoryEnabledInSpotter',
    IS_USER_PREFERENCES_MEMORY_ENABLED: 'isUserPreferencesMemoryEnabled',
    NL_INSTRUCTIONS_CHAR_LIMIT: 'nlInstructionsCharLimit',
    SHOW_FULL_KPI_VALUE_ON_TOOLTIP: 'showFullKPIValueOnTooltip',
    ENABLE_KPI_CHART_ENHANCEMENTS: 'enableKPIChartEnhancements',
    MUZE_CHART_PHASE_1_ENABLED: 'muzeChartPhase1Enabled',
    MUZE_DONUT_CHART_ENABLED: 'muzeDonutChartEnabled',
    MUZE_CANDLESTICK_CHART_ENABLED: 'muzeCandlestickChartEnabled',
    MUZE_SCATTER_CHART_ENABLED: 'muzeScatterChartEnabled',
    MUZE_BUBBLE_CHART_ENABLED: 'muzeBubbleChartEnabled',
    MUZE_HEATMAP_CHART_ENABLED: 'muzeHeatmapChartEnabled',
    MUZE_WATERFALL_CHART_ENABLED: 'muzeWaterfallChartEnabled',
    MUZE_PARETO_CHART_ENABLED: 'muzeParetoChartEnabled',
    MUZE_FUNNEL_CHART_ENABLED: 'muzeFunnelChartEnabled',
    MUZE_CHART_PHASE_1_ENABLED_GA: 'muzeChartPhase1EnabledGA',
    ENABLE_THEME_BUILDER: 'enableThemeBuilder',
    ADMIN_MODERN_EXPERIENCE: {
        CONFIG: 'adminModernExperienceConfig',
        ENABLED: 'enabled',
        FEATURE_MANAGEMENT_ENABLED: 'featureManagementEnabled',
        ADMIN_ROUTING_ENABLED: 'adminRoutingEnabled',
    },
    RADIANT_THEME_ENABLED: 'radiantThemeEnabled',
    IMPERSONATION: {
        CONFIG: 'impersonationConfig',
        ENABLED: 'enabled',
    },
    FRONTEND_TRACING_ENABLED: 'frontendTracingEnabled',
    ENABLE_COLUMN_DELETION_WITH_DEPENDENTS: 'enableColumnDeletionWithDependents',
    ENABLE_SPOTTER_AI_CONTEXT_ON_MODEL_SAVE: 'enableSpotterAiContextOnModelSave',
};
//# sourceMappingURL=json-constants.js.map